module.exports = {
  messages: {
    A11Y_LOGO: 'Zur XING Startseite',
    A11Y_SETTINGS_DROPDOWN_LABEL: 'Einstellungen verwalten',
    A11Y_XDS_CONNECTION_DEGREE_1: 'Kontakt 1. Grades',
    A11Y_XDS_CONNECTION_DEGREE_2: 'Kontakt 2. Grades',
    A11Y_XDS_CONNECTION_DEGREE_3: 'Kontakt 3. Grades',
    ACCOUNTS_CHANGE_PHONE_ACTIVATION_SMS_TEXT:
      '{code} ist Dein XING Aktivierungscode.',
    ACCOUNTS_SETTINGS_ERROR_PENDING_EMAIL_ERROR:
      'Das hat leider nicht geklappt. Bitte versuch es später nochmal.',
    ACTION_BLOCK_USER: 'Blockieren',
    ACTION_BLOCK_USER_DIALOG_DESCRIPTION:
      'Wenn Du {displayName} blockierst, kann Dich dieses Mitglied nicht mehr auf XING kontaktieren.',
    ACTION_BLOCK_USER_DIALOG_TITLE:
      'Möchtest Du Dein Profil für dieses Mitglied blockieren?',
    ACTION_BLOCK_USER_SUCCESS: 'Mitglied blockiert',
    ACTIVE_LANGUAGE: 'Deutsch',
    ADVERTISING_DIGITAL_SERVICE_ACT_HEADLINE: 'Warum siehst Du diese Anzeige?',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_CTA: 'Erfahre hier mehr',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_FOOTER_MESSAGE:
      'über mögliche Zielgruppen-Kriterien.',
    ADVERTISING_DIGITAL_SERVICE_ACT_POP_UP_MESSAGE:
      'Du siehst diese Anzeige, weil Du eines oder mehrere der Targeting-Kriterien des Werbetreibenden erfüllst.',
    ADVERTISING_LEAD_AD_FORM_CHECKBOX_ERROR:
      'Bitte das Häkchen setzen, um fortzufahren',
    ARMSTRONG_DISCO_NAVIGATION_ICON_TEXT: 'Austausch',
    BREWERY_NOCOOKIES_LINK_TARGET:
      'https://faq.xing.com/de/sicherheit/was-sind-cookies-und-warum-brauche-ich-sie-beim-einloggen',
    BREWERY_NOCOOKIES_LINK_TEXT: 'Cookies aktivieren',
    BREWERY_NOCOOKIES_PARAGRAPH:
      "Denn nur mit aktivierten Cookies funktioniert das Einloggen. Hier erfährst Du, wie's geht: ",
    BREWERY_NOCOOKIES_TITLE: 'Bitte aktiviere die Cookies.',
    BREWERY_NOJAVASCRIPT_LINK_TARGET:
      'https://faq.xing.com/de/einstellungen/javascript-meinem-browser-aktivieren',
    BREWERY_NOJAVASCRIPT_LINK_TEXT: 'JavaScript aktivieren',
    BREWERY_NOJAVASCRIPT_PARAGRAPH:
      "Aktivier bitte JavaScript, denn nur so siehst Du alle unsere Inhalte. Hier erfährst Du, wie's geht:",
    BREWERY_NOJAVASCRIPT_TITLE: 'Bitte aktiviere JavaScript.',
    BUTTON_BACK: 'Zurück',
    BUTTON_CANCEL: 'Abbrechen',
    BUTTON_CLOSE: 'Schließen',
    BUTTON_CLOSEWINDOW: 'Fenster schließen',
    BUTTON_CONTINUE: 'OK',
    BUTTON_EDIT: 'Bearbeiten',
    BUTTON_FORWARD: 'Weiter',
    BUTTON_NEXT: 'Weiter',
    BUTTON_SAVE: 'Speichern',
    BUTTON_SEND_CONFIRMATION_EMAIL: 'Erneut senden',
    CAL_DATE_FORMAT: 'DD.MM.YYYY',
    CAL_DATE_FORMAT_HINT: 'TT.MM.JJJJ',
    CB_POSTING_ERROR:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    COMMBOX_ACTOR_SWITCH_CANCEL: 'Absender beibehalten',
    COMMBOX_ACTOR_SWITCH_CONFIRM: 'Absender ändern',
    COMMBOX_ACTOR_SWITCH_HEADLINE:
      'Wer soll der Absender dieses Beitrags sein?',
    COMMBOX_ACTOR_SWITCH_HINT:
      'Um den Absender dieses Beitrags zu ändern, tipp einfach oben auf den Namen.',
    COMMBOX_ACTOR_SWITCH_PROMPT_IMAGE:
      'Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Bild geht dabei verloren.',
    COMMBOX_ACTOR_SWITCH_PROMPT_VIDEO:
      'Sicher, dass Du den Absender ändern möchtest? Dein bereits hochgeladenes Video geht dabei verloren.',
    COMMBOX_ACTOR_SWITCH_TYPE_PAGE: 'Eine Seite',
    COMMBOX_ACTOR_SWITCH_TYPE_USER: 'Eine Person',
    COMMBOX_ALMOST_FULL_FILLED_DROPZONE_HEADER:
      '1 Bild kannst Du noch hinzufügen.',
    COMMBOX_AUDIENCE_CITY_CONTACTS:
      'Nur Kontakte in meinem Arbeitsort ({totalCount})',
    COMMBOX_AUDIENCE_FOLLOWERS: 'Nur Follower',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS: 'Follower & Kontakte',
    COMMBOX_AUDIENCE_FOLLOWERS_AND_CONTACTS_DESC:
      'Dein Beitrag kann geteilt werden.',
    COMMBOX_AUDIENCE_FOLLOWERS_DESC: 'Dein Beitrag kann geteilt werden.',
    COMMBOX_AUDIENCE_HEADLINE: 'Wer darf das sehen?',
    COMMBOX_AUDIENCE_PRIVATE: 'Privat (nur XING Kontakte)',
    COMMBOX_AUDIENCE_PRIVATE_DESC: 'Dein Beitrag kann nicht geteilt werden.',
    COMMBOX_AUDIENCE_PRIVATE_SELECTED: 'Privat',
    COMMBOX_AUDIENCE_PUBLIC: 'Öffentlich',
    COMMBOX_AUDIENCE_PUBLIC_DESC: 'Jeder kann Deinen Beitrag sehen und teilen.',
    COMMBOX_BUTTON_ADD_VIDEO_LABEL: 'Video hinzufügen',
    COMMBOX_BUTTON_OPEN_FILES_LABEL: 'Dokument hinzufügen',
    COMMBOX_BUTTON_OPEN_POLL_LABEL: 'Umfrage starten',
    COMMBOX_CANCEL_POSTING_BUTTON_BACK: 'Weiter bearbeiten',
    COMMBOX_CANCEL_POSTING_BUTTON_CANCEL: 'Beitrag verwerfen',
    COMMBOX_CANCEL_POSTING_HEADLINE: 'Möchtest Du den Beitrag verwerfen?',
    COMMBOX_CANCEL_POSTING_TEXT_MESSAGE: 'Deine Eingaben gehen dann verloren.',
    COMMBOX_CHARACTERS_LEFT: 'übrig',
    COMMBOX_EMPTY_DROPZONE_BUTTON_TEXT: 'Bilder auswählen',
    COMMBOX_EMPTY_DROPZONE_TEXT:
      'JPG, BMG oder PNG (max. {max_size} MB pro Bild)',
    COMMBOX_EMPTY_DROPZONE_TITLE:
      'Du kannst bis zu {max_images} Bilder hierher ziehen oder auswählen.',
    COMMBOX_EMPTY_TEXT_FIELD: 'Teil ein Foto, einen Link oder schreib was …',
    COMMBOX_EMPTY_TEXT_FIELD_MENTIONS:
      'Teil ein Foto, einen Link oder einen Gedanken (mit "@" andere erwähnen) ...',
    COMMBOX_ENTRY_POINT_LABEL: 'Eingabefeld für Deinen Beitrag',
    COMMBOX_ENTRY_POINT_TEXT: 'Was gibt’s Neues?',
    COMMBOX_FILLED_DROPZONE_HEADER:
      '{pictures} Bilder kannst Du noch hinzufügen.',
    COMMBOX_FULL_FILLED_DROPZONE_HEADER:
      'Du hast jetzt die maximale Anzahl an Fotos hinzugefügt.',
    COMMBOX_IMAGE_BUTTON_LABEL: 'Bild hinzufügen',
    COMMBOX_IMAGE_SIZE_UPLOAD_ERROR:
      'Bitte wähle ein Bild, das max. 10 MB groß ist.',
    COMMBOX_IMAGE_TYPE_UPLOAD_ERROR:
      'Bitte wähle ein Bild im JPG- oder PNG-Format.',
    COMMBOX_POST: 'Teilen',
    COMMBOX_SUCCESS_ACTION: 'Beitrag ansehen',
    COMMBOX_SUCCESS_DESC: 'Dein Beitrag wurde auf XING geteilt.',
    COMMBOX_SUCCESS_HEADLINE: 'Und fertig!',
    COMMBOX_SUCCESS_SCHEDULED_DESC:
      'Dein Beitrag wird am {date} um {time} Uhr geteilt.',
    COMMBOX_UPDATE_BTN: 'Speichern',
    COMMBOX_UPLOADED_IMAGES_LIMIT_REACHED:
      'Du hast schon 10 Bilder hinzugefügt – mehr geht leider nicht.',
    COMMBOX_VIDEO_UPLOAD_ENCODING_TITLE:
      'Das Video wird gerade vorbereitet ... einen Moment Geduld bitte.',
    COMMBOX_VIDEO_UPLOAD_GENERIC_ERROR:
      'Das hat leider nicht geklappt – einfach gleich nochmal versuchen!',
    COMMBOX_VIEW_POST_BTN: 'Beitrag ansehen',
    COMMENT_BUTTON_LABEL: 'Kommentieren',
    CONTENT_ERROR_404_BUTTON: 'Zur XING Startseite',
    CONTENT_ERROR_404_HEADLINE:
      'Es tut uns leid: Diese Seite ist leider wie vom Winde verweht.',
    CONTENT_ERROR_404_SUBLINE:
      "Aber hier gibt's garantiert etwas zu entdecken:",
    CONTENT_ERROR_503_HEADLINE:
      'Sieht so aus, als hätten wir gerade ein kleines Problem.',
    CONTENT_ERROR_503_SUBLINE:
      'Bitte hab einen Moment Geduld. Wir arbeiten daran.',
    CONTENT_ERROR_OFFLINE:
      "Bitte prüfe Deine Internet-Verbindung. Versuch's dann einfach noch einmal.",
    CONTENT_FOLLOW: 'Folgen',
    CONTENT_FOLLOWED: 'Folgst Du',
    CONTENT_SWITCHER_MORE: 'Mehr',
    CONTENT_TIMESTAMP_AN_HOUR_AGO_LONG:
      '{minutesCount, plural,\n   =1 {Eben gerade}\n   other {Vor # Minuten}\n}',
    CONTENT_TIMESTAMP_AN_HOUR_AGO_SHORT:
      '{minutesCount, plural,\n   =1 {Jetzt}\n   other {# Min.}\n}',
    CONTENT_TIMESTAMP_DAYS: 'Tage',
    CONTENT_TIMESTAMP_DAYS_AGO_LONG:
      '{daysCount, plural,\n    =0 {Heute}\n    one {Gestern}\n    other {Vor # Tagen}\n}',
    CONTENT_TIMESTAMP_DAYS_AGO_SHORT:
      '{daysCount, plural,\n    =0 {Heute}\n    one {Gestern}\n    other {# Tage}\n}',
    CONTENT_TIMESTAMP_LESS_THAN_A_MINUTE_AGO: 'Gerade eben',
    CONTENT_TIMESTAMP_SOME_HOUR_AGO_SHORT:
      '{hoursCount, plural,\n   =1 {1 Std.}\n   other {# Std.}\n}',
    CONTENT_TIMESTAMP_SOME_HOURS_AGO_LONG:
      '{hoursCount, plural,\n   =1 {Vor 1 Stunde}\n   other {Vor # Stunden}\n}',
    CONTENT_TIMESTAMP_TODAY: 'Heute',
    CONTENT_UNFOLLOW: 'Nicht mehr folgen',
    CONTENT_VIDEO_ARTICLE_HEADLINE_PLACEHOLDER:
      'Geben Sie hier den Titel Ihres Videos ein.',
    CONTENT_VIDEO_RECOS_REASON: 'Beliebte Videos auf XING',
    COUNTRY_LIST:
      "ad\\tAndorra\nae\\tVereinigte Arabische Emirate\naf\\tAfghanistan\nag\\tAntigua und Barbuda\nal\\tAlbanien\nam\\tArmenien\nan\\tNiederländische Antillen\nao\\tAngola\naq\\tAntarktis\nar\\tArgentinien\nat\\tÖsterreich\nau\\tAustralien\naz\\tAserbaidschan\nba\\tBosnien-Herzegowina\nbd\\tBangladesch\nbe\\tBelgien\nbf\\tBurkina Faso\nbg\\tBulgarien\nbh\\tBahrain\nbi\\tBurundi\nbj\\tBenin\nbm\\tBermuda\nbn\\tBrunei\nbo\\tBolivien\nbr\\tBrasilien\nbs\\tBahamas\nbt\\tBhutan\nbw\\tBotswana\nby\\tWeißrußland\nca\\tKanada\ncd\\tDie Demokratische Republik Kongo\ncf\\tZentralafrikanische Republik\ncg\\tKongo\nch\\tSchweiz\nci\\tCôte d'Ivoire\ncl\\tChile\ncm\\tKamerun\ncn\\tChina\nco\\tKolumbien\ncr\\tCosta Rica\ncu\\tKuba\ncv\\tKap Verde\ncy\\tZypern\ncz\\tTschechische Republik\nde\\tDeutschland\ndj\\tDschibuti\ndk\\tDänemark\ndo\\tDominikanische Republik\ndz\\tAlgerien\nec\\tEcuador\nee\\tEstland\neg\\tÄgypten\nes\\tSpanien\net\\tÄthiopien\nfi\\tFinnland\nfr\\tFrankreich\nga\\tGabun\ngb\\tVereinigtes Königreich\nge\\tGeorgien\ngf\\tFranzösisch Guyana\ngh\\tGhana\ngi\\tGibraltar\ngl\\tGrönland\ngm\\tGambia\ngn\\tGuinea\ngp\\tGuadeloupe\ngq\\tÄquatorial-Guinea\ngr\\tGriechenland\ngt\\tGuatemala\ngw\\tGuinea-Bissau\ngy\\tGuyana\nhk\\tHongkong\nhn\\tHonduras\nhr\\tKroatien\nht\\tHaiti\nhu\\tUngarn\nid\\tIndonesien\nie\\tIrland\nil\\tIsrael\nin\\tIndien\niq\\tIrak\nir\\tIran (Islamische Republik )\nis\\tIsland\nit\\tItalien\njm\\tJamaika\njo\\tJordanien\njp\\tJapan\nke\\tKenia\nkg\\tKirgistan\nkh\\tKambodscha\nkm\\tKomoren\nkp\\tNordkorea\nkr\\tSüdkorea\nkw\\tKuwait\nkz\\tKasachstan\nla\\tLaos\nlb\\tLibanon\nlc\\tKaribische Inseln - Saint Lucia\nli\\tLiechtenstein\nlk\\tSri Lanka\nlr\\tLiberia\nls\\tLesotho\nlt\\tLitauen\nlu\\tLuxemburg\nlv\\tLettland\nma\\tMarokko\nmc\\tMonaco\nmd\\tMoldawien\nmg\\tMadagaskar\nmk\\tMazedonien\nml\\tMali\nmn\\tMongolei\nmo\\tMacao\nmq\\tMartinique\nmr\\tMauretanien\nmt\\tMalta\nmu\\tMauritius\nmv\\tMalediven\nmw\\tMalawi\nmx\\tMexiko\nmy\\tMalaysia\nmz\\tMosambik\nna\\tNamibia\nnc\\tNeu-Kaledonien\nne\\tNiger\nng\\tNigeria\nni\\tNicaragua\nnl\\tNiederlande\nno\\tNorwegen\nnp\\tNepal\nnz\\tNeuseeland\nom\\tOman\npa\\tPanama\npe\\tPeru\npf\\tFranzösisch Polynesien\npg\\tPapua-Neuguinea\nph\\tPhilippinen\npk\\tPakistan\npl\\tPolen\npr\\tPuerto Rico\npt\\tPortugal\npy\\tParaguay\nro\\tRumänien\nru\\tRussische Föderation\nrw\\tRuanda\nsa\\tSaudi-Arabien\nsb\\tSalomonen\nsc\\tSeychellen\nsd\\tSudan\nse\\tSchweden\nsg\\tSingapur\nsi\\tSlowenien\nsk\\tSlowakei\nsl\\tSierra Leone\nsm\\tSan Marino\nsn\\tSenegal\nso\\tSomalia\nsr\\tSurinam\nsv\\tEl Salvador\nsy\\tSyrien\nsz\\tEswatini\ntd\\tTschad\ntg\\tTogo\nth\\tThailand\ntn\\tTunesien\ntr\\tTürkei\ntt\\tTrinidad und Tobago\ntw\\tTaiwan\ntz\\tTansania\nua\\tUkraine\nug\\tUganda\nus\\tVereinigte Staaten\nuy\\tUruguay\nuz\\tUsbekistan\nva\\tVatikanstadt\nve\\tVenezuela\nvn\\tVietnam\nye\\tJemen\nza\\tSüdafrika\nzm\\tZambia\nzw\\tZimbabwe",
    COUNTRY_LIST_EXTENDED:
      'as\tAmerikanisch-Samoa\nai\tAnguilla\naw\tAruba\nbb\tBarbados\nbz\tBelize\nky\tCayman-Inseln\nck\tCook-Inseln\ndm\tDominika\ner\tEritrea\nfo\tFaroer-Inseln\nfj\tFidschi-Inseln\ngd\tGrenada\ngu\tGuam\nvg\tJungfern-Inseln (UK)\nvi\tJungfern-Inseln (USA)\nqa\tKatar\nki\tKiribati\nly\tLibyen\nmp\tNördliche Marianen-Inseln\nmh\tMarschall-Inseln\nyt\tMayotte\nfm\tMikronesien\nms\tMontserrat\nnr\tNauru\nnu\tNiue-Inseln\nnf\tNorfolk-Inseln\nom\tOman\npw\tPalau-Inseln\nre\tReunion\nkn\tSaint Christopher/Kitts\npm\tSaint Pierre et Miquelon\nvc\tSaint Vincent u. Grenadien\nws\tSamoa-Inseln\nsh\tSankt Helena\nst\tSao Tome & Principe\ntj\tTadschikistan\ntk\tTokelau\ntl\tOst-Timor\nto\tTonga\ntm\tTurkmenistan\ntc\tTurks- und Caicos Inseln\ntv\tTuvalu\nvu\tVanuatu\nwf\tWallis und Futuna\ncx\tWeihnachtsinsel\nmm\tBurma\nrs\tSerbien\nme\tMontenegro\ngg\tGuernsey\nsj\tSvalbard und Jan Mayen-Inseln\nhm\tHeard und McDonald-Inseln\nbv\tBouvetinsel\nps\tPalästinensisches Gebiet, Besetztes\npn\tPitcairn\num\tUnited States Minor Outlying Islands\ntf\tFranzösische Gebiete im südlichen Indischen Ozean\ngs\tSüdgeorgien und Südliche Sandwichinseln\neh\tWestsahara\nfk\tFalklandinseln (Malwinen)\nax\tÄlandinseln\nje\tJersey                                 \ncc\tKokosinseln   \nio\tBritisches Territorium im Indischen Ozean\nim\tIsle of Man\nbl\tSankt Bartholomäus\nbq\tBonaire, Sint Eustatius und Saba\ncw\tCuraçao\nmf\tSaint-Martin (französischer Teil)\nss\tSüdsudan\nsx\tSint Maarten (niederländischer Teil)\naf\tAfghanistan\nxk\tKosovo',
    CRATE_DEACTIVATED_PAGE_TITLE: 'XING',
    CRATE_LOGIN_PASSWORD_RECOVERY_CONFIRM_EMAIL:
      'Falls dieses Nutzerkonto existiert, erhältst Du gleich eine E-Mail an {email} mit dem Wiederherstellungs-Code. Gib diesen bitte hier ein.',
    CRATE_REACTIVATION_PAGE_TITLE: 'XING',
    CRATE_RECOVERY_NO_ACCESS_PAGE_TITLE: 'XING - E-Mail-Adresse vergessen',
    CRATE_RECOVERY_PASSWORD_PAGE_TITLE: 'XING - Passwort vergessen',
    CRATE_REGISTRATION_PAGE_TITLE: 'Bei XING registrieren',
    CRATE_SECURITY_CHECK_PAGE_TITLE: 'XING - Passwort ändern',
    CROSSPOST_SHARE_ERROR:
      'Bitte nicht übertreiben. Du hast den Beitrag schon in 3 Gruppen geteilt.',
    DAY_NAMES: 'Montag,Dienstag,Mittwoch,Donnerstag,Freitag,Samstag,Sonntag',
    DAY_NAMES_SHORT: 'Mo,Di,Mi,Do,Fr,Sa,So',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_CONFIRM: 'Ja, deaktivieren',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_HEADLINE: '@-Erwähnung deaktivieren?',
    DISCO_DOT_MENU_BLOCK_MENTIONS_DIALOG_TEXT:
      'Dein Name wird hier dann nicht mehr mit Deinem Profil verlinkt.',
    'DISCO_OBJECTS_FOLLOWER.one': 'Follower',
    'DISCO_OBJECTS_FOLLOWER.other': 'Follower',
    'DISCO_OBJECTS_FOLLOWER.zero': 'Follower',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_COMPANIES: 'Ein Unternehmen',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_EVENTS: 'Ein Event',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_GROUPS: 'Eine Gruppe',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_JOBS: 'Einen Job',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_MEMBERS: 'Eine Person',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_NEWS: 'Einen Artikel',
    DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_TOPICS: 'Ein Thema',
    DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS: 'Entdecke {keyword}-Jobs.',
    DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS_SHORT:
      '{keyword}-Jobs entdecken',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_INCREMENTAL_SEARCH: 'Suchvorschläge',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_NAVIGATION_SUGGESTIONS: 'Was suchst Du?',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_QUERY_SUGGESTION: 'Suchvorschläge',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_INTERACTIONS:
      'Profile, die Du besucht hast',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECENT_SEARCHES:
      'Deine letzten Job-Suchen',
    DS_PREDICTIVE_SEARCH_SECTION_TITLE_RECOMMENDATION: 'Empfehlungen',
    DUPLICATE_SHARE_ERROR:
      'Du hast dies schon geteilt – Dein Netzwerk ist also bestens informiert.',
    EMAIL_REG_NEWSLETTER_HINT:
      'Die E-Mail-Adresse wird ausschließlich von XING verwendet und nicht weitergegeben. Ich erhalte wahlweise Newsletter und Empfehlungen.',
    ERROR_LOGIN:
      'Deine Zugangsdaten stimmen leider nicht. Bitte überprüf sie und versuch\'s nochmal. <a href="https://login.xing.com/recovery">Probleme beim Einloggen?</a>',
    ERROR_LOGIN_COOKIE:
      "Deine Browser-Cookies konnten nicht erkannt werden. Zum Einloggen aktivier bitte die Cookies und versuch's nochmal.",
    ERROR_LOGIN_UNCONFIRMED:
      'Dieser Benutzername ist zurzeit unbestätigt. Bitte warte die Bestätigungs-E-Mail ab und klick darin auf den entsprechenden Link. Hast Du die Mail nicht bekommen? <a  href="/app/user?op=reconfirm&user_name={+UN}">Bestätigungs-Mail erneut zusenden</a>',
    ERROR_PROFILE_OLD_PASSWORD: 'Das eingegebene Passwort ist nicht korrekt.',
    ERROR_REGISTER_PASSWORD_EMAIL_RAILS:
      'Zu Deiner Sicherheit solltest Du nicht Deine E-Mail-Adresse als Passwort \nwählen.',
    ERROR_REGISTER_PASSWORD_FN_RAILS:
      'Zu Deiner Sicherheit solltest Du ein anderes Passwort \nwählen als Deinen Vornamen.',
    ERROR_REGISTER_PASSWORD_LN_RAILS:
      'Zu Deiner Sicherheit solltest Du ein anderes Passwort \nwählen als Deinen Nachnamen.',
    ERROR_REGISTER_PASSWORD_RAILS:
      'Bitte gib ein Passwort mit mindestens 8 Zeichen \nein.',
    ERROR_REGISTER_PASSWORD_UN:
      'Zu Deiner Sicherheit solltest Du ein anderes Passwort wählen.',
    ERROR_SOMETHING_WENT_WRONG:
      'Da ist leider etwas schiefgelaufen. Probiere es bitte später noch einmal.',
    FOOTER_LANGUAGES: 'Sprache',
    FRAME_HEADER_SEARCH: 'Suche',
    FRAME_HEADER_UPSELL_PREMIUM: 'Premium werden',
    FRAME_HEADER_UPSELL_PROJOBS: 'ProJobs entdecken',
    FRAME_NAVIGATION_DISCO: 'Entdecken',
    FRAME_NAVIGATION_FEEDBACK_AND_HELP_SUBTITLE:
      ' Was denkst Du über die neue App?',
    FRAME_NAVIGATION_FEEDBACK_AND_HELP_TITLE: 'Dein Feedback',
    FRAME_NAVIGATION_JOBS: 'Jobs',
    FRAME_NAVIGATION_ME_HUB: 'Deins',
    FRAME_NAVIGATION_NETWORKING_ICON_TEXT: 'Netzwerken',
    FRAME_NAVIGATION_PROJOBS_UPSELL: 'ProJobs werden',
    FRAME_NAVIGATION_SUPI: 'Start',
    FRAME_NAVIGATION_UPSELL_HEADLINE: 'Angebote für Dich',
    FRAME_NAVIGATION_YOUR_PREMIUM: 'Dein Premium',
    FRAME_NAVIGATION_YOUR_PROJOBS: 'Dein ProJobs',
    HEADER_LOGIN_EMAIL: 'E-Mail-Adresse',
    HEADER_LOGIN_EMAIL_LOST: 'Probleme mit der E-Mail-Adresse',
    HEADER_LOGIN_EMAIL_OR_PHONE_LOST: 'Andere Probleme beim Einloggen',
    HEADER_LOGIN_EMAIL_PHONE: 'E-Mail',
    HEADER_LOGIN_LAND: 'Land',
    HEADER_LOGIN_PASSWORD: 'Passwort',
    HEADER_LOGIN_PASSWORD_LOST: 'Probleme beim Einloggen',
    HEADER_LOGIN_PHONE: 'Handynummer',
    HEADER_LOGIN_WITH_EMAIL: 'Mit E-Mail-Adresse einloggen',
    HEADER_LOGIN_WITH_PHONE: 'Mit Handynummer einloggen',
    HEADER_SKIP_NAVIGATION: 'Navigation überspringen',
    INSIDER_FOLLOWED_BY: 'Abonniert von',
    INSIDER_FOLLOWED_BY_AND: 'und',
    INSIDER_FOLLOWED_BY_AND_MORE: 'weiteren',
    JOB_SEARCH_ALERTS_ALERT_NAME_ALL: 'Alle Jobs',
    LEAD_AD_FORM_ACCESSIBILITY_LABEL: 'Kontaktformular',
    LIKE_BUTTON_LABEL: 'Gefällt mir',
    LIKERS_LIST_HEADLINE: 'Diesen Mitgliedern gefällt das:',
    LOGIN_ACCOUNT_LOGIN_ATTEMPTS_LIMIT_REACHED:
      "Du hast leider zu oft versucht, Dich einzuloggen. Versuch's einfach in 10 Minuten nochmal.",
    LOGIN_ACCOUNT_LOGIN_ATTEMPTS_LIMIT_REACHED_SMS:
      "Aus Sicherheitsgründen können jetzt erst einmal keine Codes mehr per SMS verschickt werden. Versuch's einfach in einer Stunde nochmal.",
    LOGIN_ACCOUNT_RECOVERY_ACTIVE_CREDENTIAL_NOT_FOUND_ERROR:
      'Diesen Zugang kennen wir leider nicht.',
    LOGIN_ACCOUNT_RECOVERY_ACTIVE_CREDENTIAL_NOT_PROVIDED_ERROR:
      'Bitte gib Deine bei XING aktivierte E-Mail-Adresse oder Handynummer an.',
    LOGIN_ACCOUNT_RECOVERY_CODE_INVALID:
      'Zu Deiner Sicherheit funktioniert dieser Code nur kurze Zeit – und ist jetzt schon abgelaufen. Bitte starte den Prozess einfach nochmal.',
    LOGIN_ACCOUNT_RECOVERY_DESCRIPTION:
      'Macht nichts: Wir prüfen jetzt Deine Identität – und dann kannst Du eine neue E-mail-Adresse zum Einloggen festlegen.',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_ADD_LABEL: 'Dokument hochladen',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_CHANGE_LABEL: 'Dokument ändern',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_EXPIRATION:
      'Wie lange wird das Bild gespeichert?',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_EXPIRATION_PARAGRAPH:
      'Wir nutzen diese Bilder ausschließlich zur Prüfung Deiner Identität. Nach spätestens 30 Tagen löschen wir sie.',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_EXPIRATION_TITLE:
      'Wie lange wird das Bild gespeichert?',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO:
      "Was gibt's beim Bild zu beachten?",
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_BACKSIDE: 'Rückseite',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_BLURRY: 'Unscharf',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_COVERED: 'Verdeckt',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_CUTAWAY: 'Abgeschnitten',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_LIKE_SO: 'So geht es richtig:',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_NO_NO: 'So bitte nicht:',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_READABLE: 'Leserlich',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_SHARP: 'Scharf',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_HOW_TO_UPSIDE_DOWN: 'Verkehrt herum',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_MAX_SIZE:
      '(png, jpeg oder bmp / Max. 5 MB)',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_MISSING_ERROR:
      'Bitte füg erst ein Bild hinzu.',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_REMOVE_LABEL: 'Dokument löschen',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_SIZE_EXCEEDED_ERROR:
      'Bitte wähl ein Bild, das max. 5 MB groß ist.',
    LOGIN_ACCOUNT_RECOVERY_FILE_UPLOAD_TYPE_NOT_ACCEPTED_ERROR:
      'Bitte wähl als Bild eine JPG- oder PNG-Datei.',
    LOGIN_ACCOUNT_RECOVERY_GENERIC_ERROR:
      "Das hat leider nicht geklappt. Probier's bitte einfach später nochmal.",
    LOGIN_ACCOUNT_RECOVERY_ID_UPLOAD_DESCRIPTION:
      'Dieser Schritt dient dem Schutz Deiner Daten: Lad ein Bild mit der Vorderseite Deines Personalausweises oder Deines Führerscheins hoch.',
    LOGIN_ACCOUNT_RECOVERY_ID_UPLOAD_TITLE: 'Bestätige Deine Identität',
    LOGIN_ACCOUNT_RECOVERY_IMAGE_NOT_PROVIDED_ERROR:
      'Bitte füg ein Foto zur Identitätsprüfung hinzu.',
    LOGIN_ACCOUNT_RECOVERY_INPUT_LABEL: 'Deine bisherige E-Mail',
    LOGIN_ACCOUNT_RECOVERY_INVALID_SESSION:
      'Das hat leider nicht geklappt. Kannst Du es bitte nochmal versuchen?',
    LOGIN_ACCOUNT_RECOVERY_LINK_INVALID:
      'Zu Deiner Sicherheit funktioniert dieser Link nur kurze Zeit – und ist jetzt schon abgelaufen. Bitte starte den Prozess einfach nochmal.',
    LOGIN_ACCOUNT_RECOVERY_LOGIN_REQUIRED:
      'Leider konnten wir Deine Anfrage zum Zurücksetzen Deines Zugangs nicht finden. Bitte starte den Prozess sicherheitshalber nochmal.',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_DESCRIPTION:
      'Mit welcher E-Mail-Adresse möchtest Du Dich zukünftig bei XING einloggen?',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_INPUT_LABEL: 'Deine neue E-Mail-Adresse',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_INVALID_ERROR:
      'Dies scheint keine E-Mail-Adresse zu sein ... vielleicht vertippt?',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_NOT_PROVIDED_ERROR:
      'Bitte gib die E-Mail Adresse an, mit welcher Du Dich zukünftig bei XING einloggen willst.',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_TITLE: 'Neue E-Mail-Adresse festlegen',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_UNAVAILABLE_ERROR:
      'Wir haben Deine E-Mail-Adresse erkannt. Du kannst Dich jetzt damit einloggen oder Dein Passwort zurückzusetzen.',
    LOGIN_ACCOUNT_RECOVERY_NEW_EMAIL_UNAVAILABLE_ERROR_LINK: 'Jetzt einloggen',
    LOGIN_ACCOUNT_RECOVERY_REQUEST_LIMIT_REACHED:
      "Du hast leider zu häufig versucht, Deinen Zugang wiederherzustellen. Aus Sicherheitsgründen kannst Du's erst in zwölf Stunden wieder probieren.",
    LOGIN_ACCOUNT_RECOVERY_RESET_REQUEST_ALREADY_OPEN_ERROR:
      'Bitte bestätige erst Deine vorherige Anfrage zur Wiederherstellung Deines Zugangs.',
    LOGIN_ACCOUNT_RECOVERY_RESET_REQUEST_IN_PROCESS:
      'Du hast bereits einen Antrag zur Wiederherstellung gestellt. Wir werden uns umgehend bei Dir melden.',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_BIRTHDATE_LABEL: 'Geburtsdatum',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_CITY_LABEL: 'Stadt (optional)',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_EMAIL_1_LABEL:
      'E-Mail-Adresse 1 (optional)',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_EMAIL_2_LABEL:
      'E-Mail-Adresse 2 (optional)',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_EMAILS_EXPLANATION:
      'Gib die E-Mail-Adressen ein, mit denen Du Dich bei XING registriert haben könntest.',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_FIRSTNAME_LABEL: 'Vorname',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_LASTNAME_LABEL: 'Nachname',
    LOGIN_ACCOUNT_RECOVERY_SEARCH_CRITERIA_TITLE: 'E-Mail-Adresse vergessen?',
    LOGIN_ACCOUNT_RECOVERY_SUCCESS_FURTHER_QUESTIONS:
      'Fragen? Schreib uns gern.',
    LOGIN_ACCOUNT_RECOVERY_SUCCESS_PARAGRAPH_1:
      'Vielen Dank! Wir schreiben Dir innerhalb von 2 Werktagen an Deine neue Adresse ({username}).',
    LOGIN_ACCOUNT_RECOVERY_SUCCESS_PARAGRAPH_2:
      'Info: Hast Du Deinen Account zurzeit deaktiviert, wird er jetzt automatisch aktiviert.',
    LOGIN_ACCOUNT_RECOVERY_SUCCESS_PARAGRAPH_3:
      'Du kannst diese Seite nun schließen.',
    LOGIN_ACCOUNT_RECOVERY_SUCCESS_TITLE: 'Geschafft!',
    LOGIN_ACCOUNT_RECOVERY_TITLE: 'Kein Zugriff auf Deine E-Mail-Adresse?',
    LOGIN_ACCOUNT_RECOVERY_WRONG_CONFIRMATION_CODE:
      'Dieser Code stimmt leider nicht. Vielleicht vertippt?',
    LOGIN_ACCOUNT_SEARCH_CRITERIA_DESCRIPTION:
      'Nicht schlimm: Wir prüfen jetzt zuerst Deine Identität und danach legst Du eine neue E-Mail-Adresse fürs Einloggen fest.',
    LOGIN_ACCOUNT_SEARCH_CRITERIA_DESCRIPTION_2:
      "Los geht's mit Angaben, die Du in Deinem XING Profil hinterlegt hast:",
    LOGIN_ADMIN_BULK_PROCESS_FULL_EMAIL:
      'Hallo {first_name},\n\nDein XING Zugang war vorübergehend nicht geschützt: Wir vermuten, dass Deine Zugangsdaten (E-Mail-Adresse und Passwort) Dritten bekannt geworden sind.\n\nMit der Kombination E-Mail und Passwort versuchen Hacker oft ziellos, sich auf verschiedenen Seiten (darunter auch XING) einzuloggen – was meistens nicht klappt, manchmal aber doch.\n\nBei Deinem XING Zugang war ein solcher Login-Versuch mit hoher Wahrscheinlichkeit erfolgreich. Wir haben den Zugang deshalb umgehend gesperrt. Wir können aber leider nicht ausschließen, dass bei Deinem Profil Inhalte hinzugefügt oder entfernt wurden.\n\nOb Deine E-Mail-Adresse grundsätzlich in gestohlenen Passwortlisten auftaucht, kannst Du unter https://leakchecker.uni-bonn.de/ überprüfen. Wenn Du betroffen bist, siehst Du dort auch mögliche Quellen.\n\nDein XING Profil ist jetzt wieder aktiviert – fordere hier ein neues Passwort an:\nhttps://login.xing.com/recovery\n\nWichtig: Verwende ein neues, sicheres Passwort!\n\nTipps zur Sicherheit bei XING und einem sicheren Passwort erhältst Du hier: https://faq.xing.com/de/sicherheit/ein-sicheres-passwort\n\nFragen? Schreib uns gern:\nhttps://www.xing.com/support/contact/security/report_security_issue\n\nViele Grüße aus Hamburg\n\nDein  XING Team für User Care – Quality & Security',
    LOGIN_BLACKLISTED_P2_MAILTO_TARGET: 'mailto:de-quality@xing.com',
    LOGIN_BLACKLISTED_P2_MAILTO_TEXT: 'Support kontaktieren',
    LOGIN_BLACKLISTED_P3_HELPSECTION_LINK_TARGET:
      'https://faq.xing.com/de/sicherheit/gesperrtes-xing-profil',
    LOGIN_BLACKLISTED_P3_HELPSECTION_LINK_TEXT: 'Hilfebereich',
    LOGIN_BLACKLISTED_PARAGRAPH_1:
      'Dein XING Profil haben wir aus Sicherheitsgründen oder wegen eines Verstoßes gegen unsere AGB gesperrt.',
    LOGIN_BLACKLISTED_PARAGRAPH_2:
      'Möchtest Du es wieder freischalten, dann schreib uns an de-quality@xing.com. Idealweise mit Deiner E-Mail-Adresse oder Handy-Nummer, mit der Du Dich eingeloggt hast.',
    LOGIN_BLACKLISTED_PARAGRAPH_3:
      'Weitere Infos findest Du auch in unseren AGB in unserem {helpCenterLink}. ',
    LOGIN_BLACKLISTED_SALUTATION: 'Liebes XING Mitglied,',
    LOGIN_EMAIL_CHANGE_INFO:
      'Die Bestätigung Deiner E-Mail-Adresse war erfolgreich. Bitte logge Dich mit Deinen Zugangsdaten ein.',
    LOGIN_ENABLE_TWO_FA_SMS_TEXT:
      '{code} ist Dein Sicherheitscode, um den zweistufigen Login bei XING zu aktivieren.',
    LOGIN_FLIP_LINK_BACK: 'Mitglieder-Login',
    LOGIN_FORGOT_PASSWORD: 'Passwort vergessen?',
    LOGIN_FRONTEND_META_DESCRIPTION:
      'Finde bei XING neue Jobs, spannende Kontakte und inspirierende News.',
    LOGIN_FRONTEND_META_TITLE: 'Bei XING anmelden',
    LOGIN_GENERIC_REQUEST_LIMIT_REACHED:
      'Du hast es leider zu oft versucht. Bitte versuch es frühestens in 12 Stunden nochmal.',
    LOGIN_HEADLINE: 'Willkommen zurück!',
    LOGIN_INQUIRY_NO_DATA_REASON:
      'Du bist derzeit in keinem Internet-Browser bei XING eingeloggt.',
    LOGIN_INQUIRY_SECTION_2FA_TITLE: 'Zweistufiger Login',
    LOGIN_INQUIRY_SECTION_ACTIVE_SESSION_TITLE:
      'Wo bist Du bei XING eingeloggt?',
    LOGIN_INQUIRY_TBODY_2FA_AUTHENTICATOR:
      'Aktiviert (mit Authentifizierungs-App)',
    LOGIN_INQUIRY_TBODY_2FA_NONE: 'Nicht aktiviert',
    LOGIN_INQUIRY_TBODY_2FA_SMS: 'Aktiviert (mit SMS)',
    LOGIN_INQUIRY_THEAD_2FA_STATUS: 'Status',
    LOGIN_INQUIRY_THEAD_BROWSER: 'Browser',
    LOGIN_INQUIRY_THEAD_ISP: 'Internetanbieter',
    LOGIN_INQUIRY_THEAD_LAST_USED: 'Zuletzt verwendet',
    LOGIN_INQUIRY_THEAD_LOCATION: 'Ort',
    LOGIN_INQUIRY_THEAD_LOGIN_DATE: 'Login-Datum',
    LOGIN_INQUIRY_TITLE: 'Logins bei XING',
    LOGIN_INTERSTITIAL_SKIP_BUTTON: 'Zur Startseite',
    LOGIN_INVALID_PASSWORD:
      'Ihr Benutzername oder Passwort ist falsch. Bitte versuchen Sie es erneut.',
    LOGIN_KNOWN_USER_FEMALE: '{firstName}',
    LOGIN_KNOWN_USER_LOGIN_BUTTON: 'Jetzt einloggen',
    LOGIN_KNOWN_USER_MALE: '{firstName}',
    LOGIN_KNOWN_USER_TEXT: 'Schön, dass Du da bist,',
    LOGIN_LOGOUT_COMEBACK:
      'Du bist jetzt ausgeloggt. Noch was vergessen? {loginLink}',
    LOGIN_LOGOUT_COMEBACK_CTA: 'Wieder einloggen',
    LOGIN_LOGOUT_COMEBACK_MESSAGE:
      'Du bist jetzt ausgeloggt. Noch was vergessen?',
    LOGIN_LOGOUT_HEADLINE: 'Du bist jetzt sicher ausgeloggt.',
    LOGIN_LOGOUT_HEADLINE_DAY: 'Schönen Tag!',
    LOGIN_LOGOUT_HEADLINE_MORNING: 'Schönen Start in den Tag!',
    LOGIN_LOGOUT_HEADLINE_NIGHT: 'Schönen Abend!',
    LOGIN_LOGOUT_LOGIN_LINK_TEXT: 'Erneut einloggen',
    LOGIN_LOGOUT_META_TITLE: 'Du bist jetzt ausgeloggt. | XING',
    LOGIN_LOGOUT_SURVEY_ANSWER_NEVER_FORGET:
      'Ich vergesse meine Zugangsdaten nie.',
    LOGIN_LOGOUT_SURVEY_ANSWER_NO_TRUST: 'Ich vertraue XING nicht.',
    LOGIN_LOGOUT_SURVEY_ANSWER_NOT_MY_DEVICE:
      'Ich benutze gerade ein Gerät, das nicht mir gehört.',
    LOGIN_LOGOUT_SURVEY_ERROR_REQUIRED:
      'Verrätst Du uns noch, warum Du Dich ausgeloggt hast?',
    LOGIN_LOGOUT_SURVEY_FREE_TEXT_LABEL:
      'Anderer Grund: (Bitte hier eingeben, max. 160 Zeichen)',
    LOGIN_LOGOUT_SURVEY_HEADLINE:
      'Verrätst Du uns noch, warum Du Dich ausgeloggt hast?',
    LOGIN_LOGOUT_SURVEY_SUBMIT_LABEL: 'Antwort senden',
    LOGIN_LOGOUT_SURVEY_SUCCESS_MESSAGE: 'Vielen Dank für Deine Antwort!',
    LOGIN_NAVIGATION_LOGIN_ERROR_INVALID:
      'Wir haben Deine Eingabe gerade leider nicht erkannt. Bitte gib Deine Zugangsdaten zur Sicherheit nochmal ein.',
    LOGIN_NEW_EMAIL_LABEL: 'E-Mail',
    LOGIN_NEW_PASSWORD_LABEL: 'Passwort',
    LOGIN_NEW_PROBLEMS_TEXT: 'Probleme beim Einloggen?',
    LOGIN_NEW_REGISTER_TEXT:
      'Noch kein XING Mitglied? Jetzt kostenlos registrieren',
    LOGIN_NEW_REMEMBER_ME_TEXT: 'Eingeloggt bleiben',
    LOGIN_NEW_SUBMIT_TEXT: 'Einloggen',
    LOGIN_NEW_TITLE: 'Willkommen zurück!',
    LOGIN_NOT_ME: 'Das bist nicht Du? Benutzer wechseln',
    LOGIN_OAUTH_INFO_PARAGRAPH:
      'Bitte logg Dich mit Deinen XING Zugangsdaten ein, um {application} den Zugriff auf Deine bei XING gespeicherten Daten zu erlauben.',
    LOGIN_ONE_TIME_LINK_EXPLAINER:
      "So geht's: Wir senden Dir per E-Mail einen einmaligen Login-Link.",
    LOGIN_ONE_TIME_LINK_INVALID:
      'Dieser Link ist leider nicht mehr aktiv. Bitte logg Dich mit Deinen Zugangsdaten ein.',
    LOGIN_ONE_TIME_LINK_LINK: 'Login-Link anfordern',
    LOGIN_ONE_TIME_LINK_OR: 'oder',
    LOGIN_ONE_TIME_LINK_SUCCESS_FOOTNOTE:
      'Wichtig: Zu Deiner Sicherheit ist der Link nur 30 Minuten aktiv und auch nur einmal verwendbar.',
    LOGIN_ONE_TIME_LINK_SUCCESS_HEADLINE: 'Fast geschafft:',
    LOGIN_ONE_TIME_LINK_SUCCESS_PARAGRAPH:
      'Klick einfach auf den Link – und schon bist Du bei XING eingeloggt.',
    LOGIN_ONE_TIME_LINK_SUCCESS_PARAGRAPH_WITH_EMAIL:
      'Wir haben Deinen Login-Link an {email} gesendet.',
    LOGIN_ONE_TIME_LINK_TEASER: 'Sicher einloggen – ohne Passwort\t',
    LOGIN_ONE_TIME_LOGIN_REQUEST_LIMIT_REACHED:
      'Der Link kann aus Sicherheitsgründen nur einmal pro Minute angefordert werden. Bitte nutz Deine Zugangsdaten oder versuch es gleich noch einmal.',
    LOGIN_ONLYFY_HEADLINE:
      'Verbinde Deinen Account, indem Du Dich bei XING einloggst',
    LOGIN_ONLYFY_PLACEHOLDER_EMAIL: 'Deine XING E-Mail Adresse',
    LOGIN_ONLYFY_PLACEHOLDER_PASSWORD: 'Dein XING Passwort',
    LOGIN_ONLYFY_REGISTRATION_LINK:
      'Noch kein XING Mitglied? Jetzt kostenlos registrieren',
    LOGIN_PASSWORD_IS_RESET:
      'Dein neues Passwort ist jetzt aktiviert. Du kannst es also ab sofort zum Einloggen benutzen.',
    LOGIN_PASSWORD_PLACEHOLDER: 'Gib bitte Dein Passwort ein',
    LOGIN_PASSWORD_RECOVERY_CONFIRM_BACK:
      'E-Mail Adresse / Handynr. korrigieren',
    LOGIN_PASSWORD_RECOVERY_CONFIRM_DESCRIPTION:
      'Bitte gib den Code ein, den wir Dir gerade an {username} gesendet haben.',
    LOGIN_PASSWORD_RECOVERY_CONFIRM_SUBMIT: 'Weiter',
    LOGIN_PASSWORD_RECOVERY_CONFIRM_TITLE: 'Bestätigungscode eingeben',
    LOGIN_PASSWORD_RESET_BUTTON_CONTINUE: 'Neues Passwort festlegen',
    LOGIN_PASSWORD_RESET_LABEL_NEW: 'Neues Passwort festlegen',
    LOGIN_PASSWORD_RESET_SUBLINE:
      'Tipp: Dein Passwort ist besonders sicher, wenn es mindestens 8 Zeichen hat, idealerweise eine Mischung aus Groß- und Kleinbuchstaben, Ziffern und Sonderzeichen (z. B. *, %, §, ?).',
    LOGIN_PASSWORD_RESET_TITLE: 'Neues Passwort festlegen',
    LOGIN_PASSWORD_STRENGTH_HIGH: 'Sieht gut aus!',
    LOGIN_PASSWORD_STRENGTH_LOW: 'Noch nicht so sicher ...',
    LOGIN_PASSWORD_STRENGTH_MIDDLE: 'Schon besser ...',
    LOGIN_REACTIVATION_BUTTON_LABEL: 'XING Profil wieder aktivieren',
    LOGIN_REACTIVATION_LOG_OUT:
      'Du möchtest Dein XING Profil nicht wieder aktivieren? <a>Ausloggen</a>',
    LOGIN_REACTIVATION_PARAGRAPH:
      'Wenn Du möchtest, kannst Du es aber auch jetzt schon wieder aktivieren. Du bist dann auf XING wieder auffindbar.',
    LOGIN_REACTIVATION_SUB_TITLE:
      'Du hast Dein XING Profil bis zum {date} deaktiviert.',
    LOGIN_REACTIVATION_TITLE: 'Willkommen zurück bei XING!',
    LOGIN_RECOVERY_BACK: 'Zum Einloggen',
    LOGIN_RECOVERY_CHANGE_EMAIL: 'Weiter',
    LOGIN_RECOVERY_CHANGE_EMAIL_ARIA_LABEL: 'Weiter zum Bestätigungcode',
    LOGIN_RECOVERY_CONTINUE: 'Weiter',
    LOGIN_RECOVERY_CONTINUE_ARIA_LABEL: 'Weiter zur Identitätsbestätigung',
    LOGIN_RECOVERY_DATE_PLACEHOLDER: 'jjjj-mm-tt',
    LOGIN_RECOVERY_DESCRIPTION:
      'Kein Problem: Gib hier die E-Mail-Adresse ein, mit der Du Dich bei XING einloggst.',
    LOGIN_RECOVERY_FORGOT_CREDENTIALS: 'E-Mail-Adresse vergessen?',
    LOGIN_RECOVERY_FORGOT_CREDENTIALS_CONTINUE: 'Weiter',
    LOGIN_RECOVERY_FORGOT_CREDENTIALS_CONTINUE_ARIA_LABEL:
      'Weiter zur Identitätsbestätigung',
    LOGIN_RECOVERY_FORGOT_OR_NO_ACCESS_CREDENTIALS:
      'Probleme mit Deiner E-Mail?',
    LOGIN_RECOVERY_FORGOT_PASSWORD_CONTINUE: 'Weiter',
    LOGIN_RECOVERY_FORGOT_PASSWORD_CONTINUE_ARIA_LABEL:
      'Weiter zum Bestätigungscode',
    LOGIN_RECOVERY_INPUT_LABEL: 'E-Mail',
    LOGIN_RECOVERY_INVALID_CODE:
      'Dieser Code zum Zurücksetzen des Passwortes ist schon abgelaufen: Beantrag bitte einen neuen.',
    LOGIN_RECOVERY_INVALID_LINK:
      'Dieser Link zum Zurücksetzen des Passwortes ist schon abgelaufen: Beantrag bitte einen neuen.',
    LOGIN_RECOVERY_OTHER_PROBLEMS: 'Andere Probleme beim Einloggen?',
    LOGIN_RECOVERY_OTHER_PROBLEMS_LINK_TEXT: 'Kontaktier uns',
    LOGIN_RECOVERY_SUCESSFUL_RESET_TITLE: 'Prima, Du hast ein neues Passwort!',
    LOGIN_RECOVERY_TFA_CTA: 'Zweistufigen Login deaktivieren',
    LOGIN_RECOVERY_TFA_DESCRIPTION_1:
      'Mit dem Ersatz-Code deaktivierst Du den zweistufigen Login. Du kannst Dich damit auch einloggen. Den Ersatz-Code hast Du von uns bekommen, als Du den zweistufigen Login aktiviert hast.',
    LOGIN_RECOVERY_TFA_DESCRIPTION_2: 'Meld Dich bitte bei uns.',
    LOGIN_RECOVERY_TFA_EMAIL_BODY:
      'Deaktiviert bitte den zweistufigen Login meines Accounts.\nMein Account: [Bitte füg hier den Link Deines Profils ein.]\n \nAls Nachweis meiner Identität schick ich eine Kopie meines Ausweises, Führerscheins oder meiner Gesundheitskarte (Vorder- und Rückseite).\n[Füg bitte als Anhang ein Foto Deines Ausweises, Führerscheins oder Deiner Gesundheitskarte ein.]',
    LOGIN_RECOVERY_TFA_EMAIL_SUBJECT: 'Probleme mit dem zweistufigem Login',
    LOGIN_RECOVERY_TFA_HEADER: 'Probleme mit dem zweistufigen Login',
    LOGIN_RECOVERY_TFA_SUBHEADER_1:
      'Hast Du den zweistufigen Login aktiviert und kannst gerade keine Login-Codes empfangen?',
    LOGIN_RECOVERY_TFA_SUBHEADER_2: 'Hast Du Deinen Ersatz-Code vergessen?',
    LOGIN_RECOVERY_TITLE: 'Passwort vergessen?',
    LOGIN_RECOVERY_UPLOAD: 'Weiter',
    LOGIN_RECOVERY_UPLOAD_ARIA_LABEL: 'Weiter, um die E-Mail-Adresse zu ändern',
    LOGIN_REGISTRATION_CONTINUE: 'Weiter',
    LOGIN_REGISTRATION_CONTINUE_ARIA_LABEL:
      'Weiter zur Registrierung und E-Mail-Bestätigung',
    LOGIN_REGISTRATION_HEADLINE:
      'Jetzt registrieren – gratis und in nur 2 Minuten!',
    LOGIN_REGISTRATION_SIGNIN_HEADLINE: 'Einloggen',
    LOGIN_REGISTRATION_SUBHEADLINE: 'Bereits Mitglied bei XING? {signin}',
    LOGIN_RESEND_CODE_SEND: 'Code nicht erhalten? {link}.',
    LOGIN_RESEND_CODE_SEND_LINK: 'Erneut senden',
    LOGIN_RESEND_CODE_WAIT:
      'Bitte warte noch {countdown} Sekunden auf den Erhalt des Codes.',
    LOGIN_RESEND_LINK_SEND: 'Link nicht erhalten? {link}',
    LOGIN_RESEND_LINK_SEND_LINK: 'Erneut senden',
    LOGIN_RESEND_LINK_WAIT:
      'Du solltest den Link in spätestens {countdown} Sekunden bekommen.',
    LOGIN_SEPARATOR: 'oder',
    LOGIN_SETTINGS_ERROR_ACTIVE_PASSWORD_INCORRECT:
      'Du hast {count}-mal Dein Passwort falsch eingegeben. Zu Deiner Sicherheit loggen wir Dich nach dem 3. falschen Versuch aus.',
    LOGIN_SETTINGS_ERROR_ACTIVE_PASSWORD_MISSING:
      'Bitte gib noch Dein neues Passwort ein.',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_EQ_EMAIL:
      'Deine E-Mail-Adresse sollte nicht gleichzeitig Dein Passwort sein: Das kann zu leicht erraten werden!',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_EQ_FIRST_NAME:
      'Dein Name sollte nicht Dein Passwort sein: Das kann zu leicht erraten werden!',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_EQ_LAST_NAME:
      'Dein Nachname sollte nicht Dein Passwort sein: Das kann zu leicht erraten werden!',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_EQ_USER_NAME:
      'Dein Nutzername sollte nicht gleichzeitig Dein Passwort sein: Das kann zu leicht erraten werden!',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_FOUND_LEAKED:
      'Dein neues Passwort und Deine E-Mail-Adresse stehen in einer Datenbank für geleakte Login-Daten. Das haben wir beim standardmäßigen Prüfen neuer Passwörter festgestellt. Bitte wähl deshalb ein ganz neues Passwort.',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_MISSING:
      'Bitte gib noch das neue Passwort ein.',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_TOO_LONG:
      'Bitte gib als Passwort max. 1024 Zeichen ein.',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_TOO_SHORT:
      'Bitte gib als Passwort mind. 8 Zeichen ein.',
    LOGIN_SETTINGS_ERROR_NEW_PASSWORD_USED_BEFORE:
      'Zu Deiner Sicherheit kannst Du dieses Passwort nicht verwenden: Du hast es schon einmal als Passwort benutzt.',
    LOGIN_SETTINGS_ERROR_PASSWORD_TOKEN_INVALID_PASSWORD:
      'Dieses Passwort stimmt leider nicht – vielleicht vertippt?',
    LOGIN_SETTINGS_ERROR_PASSWORD_TOKEN_PASSWORD_MISSING:
      'Bitte gib hier Dein XING Passwort ein.',
    LOGIN_SETTINGS_ERROR_TFA_ACTIVE_PHONE_UNDEFINED:
      'Bitte füg hier erst eine Handynummer hinzu. Diese kannst Du dann für den zweistufigen Login nutzen.',
    LOGIN_SETTINGS_ERROR_TFA_ALREADY_ACTIVE:
      'Gute Nachrichten: Du bist bereits mit dem zweistufigen Login geschützt.',
    LOGIN_SETTINGS_ERROR_TFA_ALREADY_INACTIVE:
      'Der zweistufige Login ist momentan nicht aktiviert.',
    LOGIN_SETTINGS_ERROR_TFA_ATTEMPT_LIMIT_REACHED:
      'Du hast es leider zu oft versucht. Bitte versuch es später nochmal. ',
    LOGIN_SETTINGS_ERROR_TFA_INVALID_CODE:
      'Dieser Code stimmt leider nicht ... vielleicht vertippt?',
    LOGIN_SETTINGS_ERROR_TFA_INVALID_TOKEN:
      'Der Zeitraum zur Passwort-Eingabe ist leider abgelaufen. Kannst Du Dein Passwort bitte nochmal eingeben?',
    LOGIN_SIGNUP_HEADLINE: 'Jetzt kostenlos registrieren',
    LOGIN_SUBHEADLINE: 'Noch kein XING Mitglied? {signup}',
    LOGIN_TFA_BACKUP_CODE_DESCRIPTION:
      'Wichtig: Der zweistufige Login wird dabei deaktiviert. Geh einfach in Deine Einstellungen, um ihn wieder zu aktivieren.',
    LOGIN_TFA_BACKUP_CODE_EXPLANATION_LINK: 'Ersatzcode nicht verfügbar?',
    LOGIN_TFA_BACKUP_CODE_FORM_LABEL: 'Aktueller Ersatzcode',
    LOGIN_TFA_BACKUP_CODE_FORM_LABEL_WITH_PREFIX:
      'Dein Ersatz-Code (beginnt mit {prefix})',
    LOGIN_TFA_BACKUP_CODE_GO_BACK_LINK: 'Zurück',
    LOGIN_TFA_BACKUP_CODE_LINK: 'Code nicht zugänglich?',
    LOGIN_TFA_BACKUP_CODE_MODAL_CONTACT_LINK: 'kontaktier uns bitte.',
    LOGIN_TFA_BACKUP_CODE_MODAL_CONTACT_TEXT:
      'Wenn dies nicht möglich ist, {link}',
    LOGIN_TFA_BACKUP_CODE_MODAL_DESCRIPTION:
      'Bei der Aktivierung des zweistufigen Logins hast Du einen Ersatzcode erhalten. Gib diesen hier ein, um Dich einzuloggen.',
    LOGIN_TFA_BACKUP_CODE_SUBMIT_TEXT: 'Einloggen',
    LOGIN_TFA_BACKUP_CODE_TITLE: 'Mit Ersatzcode einloggen',
    LOGIN_TWO_FA_SMS_TEXT:
      'Verwende {code} als Sicherheitscode für Deine Anmeldung bei XING.',
    LOGIN_TWOFA_AUTHENTICATOR_BUTTON_LABEL: 'Verifizieren',
    LOGIN_TWOFA_AUTHENTICATOR_DESCRIPTION:
      'Bitte gib hier den einmaligen Zugangscode ein, der Dir in Deiner Authentifizierungs-App angezeigt wird.',
    LOGIN_TWOFA_AUTHENTICATOR_LABEL: 'Einmaliger Zugangscode',
    LOGIN_TWOFA_AUTHENTICATOR_TITLE: 'Zugangscode eingeben',
    LOGIN_TWOFA_ERROR_INVALID_CODE:
      'Dieser Code stimmt leider nicht. Hast Du Dich vielleicht vertippt?',
    LOGIN_TWOFA_HINT_AUTHENTICATOR:
      'Du bekommst den Zugangscode in Deiner Authentifizierungs-App.',
    LOGIN_TWOFA_HINT_SMS:
      'Du bekommst in Kürze den Code per SMS auf die Handy-Nummer mit diesen Endziffern: {phone}',
    LOGIN_TWOFA_SMS_BUTTON_LABEL: 'Verifizieren',
    LOGIN_TWOFA_SMS_DESCRIPTION:
      'Wir haben den Code per SMS an die Handynr. mit dieser Endung gesendet: \n{anonymizedPhone}',
    LOGIN_TWOFA_SMS_LABEL: 'Einmaliger Zugangscode',
    LOGIN_TWOFA_SMS_RESEND_SMS_SEND: 'Code erneut senden',
    LOGIN_TWOFA_SMS_RESEND_SMS_WAIT:
      'Bitte warte noch {countdown} Sekunden auf den Erhalt der SMS.',
    LOGIN_TWOFA_SMS_TITLE: 'Zugangscode eingeben',
    LOGIN_TWOFA_WHITELIST_BROWSER:
      'In diesem Browser keinen Zugangscode mehr nutzen',
    LOGINHTML_EXPL_ENTER:
      'Trag hier Deine Zugangsdaten ein. <strong>Zum Einloggen müssen Cookies aktiviert sein.</strong>',
    LOGINHTML_EXPL_FORGOT:
      '<a href="https://login.xing.com/recovery" class="info">Passwort vergessen?</a>',
    LOGINHTML_EXPL_REG:
      'Noch kein XING Mitglied?<br>\nKostenlos <a href="/signup">registrieren</a>!',
    LOGINHTML_HEADLINE: 'Einloggen',
    LOGINHTML_LOGINBUTTON: 'Einloggen',
    LOGINHTML_SUBHEADLINE: 'Schon XING Mitglied? Dann logg Dich hier ein.',
    MALT_FILE_UPLOAD_ERROR_MESSAGE:
      'Die Datei "{filesTooBig}" ist leider zu groß: Bis zu {maxSize} MB sind erlaubt.',
    MALT_FILE_UPLOAD_ERROR_MESSAGE_PLURAL:
      'Du kannst Dateien von bis zu {maxSize} MB hochladen. Diese Dateien sind daher leider zu groß: {filesTooBig}',
    MALT_FILE_UPLOAD_NO_FILE: 'Noch keine Datei ausgewählt',
    MALT_FILE_UPLOAD_NUMBER_OF_FILES: '{numberOfFiles} Dateien',
    MALT_FOOTER_COPYRIGHT_API: '© {siteoperator} | Alle Rechte vorbehalten',
    MALT_IMAGE_UPLOAD_BROWSE_BUTTON: 'Datei auswählen',
    MALT_TEST_RUBY_STYLE_TRANSLATION: 'Mein Name ist {name}.',
    MALT_WELCOME_LOGIN_SETTINGS_LAND_DROPDOWN_AT: 'Österreich',
    MALT_WELCOME_LOGIN_SETTINGS_LAND_DROPDOWN_CH: 'Schweiz',
    MALT_WELCOME_LOGIN_SETTINGS_LAND_DROPDOWN_DE: 'Deutschland',
    MESSENGER_SHARE_COMMENT_PLACEHOLDER:
      'Hier kannst Du Deinen Link kommentieren.',
    MESSENGER_SHARE_RECEIPENT_SELECTION_FORM_LABEL: 'Empfänger:',
    MESSENGER_SHARE_RECEIPENT_SELECTION_PLACEHOLDER: 'Empfänger eingeben',
    MESSENGER_SHARE_TARGET_LABEL: 'Deine Nachricht:',
    MONTH_NAMES:
      'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember',
    MONTH_NAMES_SHORT: 'Jan,Feb,Mär,Apr,Mai,Jun,Jul,Aug,Sep,Okt,Nov,Dez',
    MORE_OPTIONS_ACCESSIBILITY_LABEL: 'Mehr Optionen',
    MYXING_LOADING_ALERT_MESSAGE:
      'Das hat leider nicht geklappt. Bitte aktualisiere diese Seite noch einmal.',
    MYXS_HEADLINE: 'Wo bist Du bei XING eingeloggt?',
    NATIVE_ADS_DOT_MENU_REPORT_OBJECT: 'Anzeige melden',
    NATIVE_ADS_LEARN_MORE_BUTTON: 'Mehr erfahren',
    NATIVE_ADS_SPONSORED_LABEL: 'Gesponsert',
    NBA_BUTTON_CANCEL: 'Abbrechen',
    NBA_BUTTON_CHANGE_IMAGE: 'Bild ändern',
    NBA_BUTTON_CONTINUE: 'Weiter',
    NBA_CREATE_PHOTO_CARD_BENEFIT_TEXT:
      'Ein gutes Profilbild unterstreicht Dein professionelles Auftreten und erhöht die Anzahl Deiner Profilbesuche.',
    NBA_CREATE_PHOTO_CARD_GENERIC_ERROR:
      "Das hat leider nicht geklappt – kannst Du's nochmal versuchen?",
    NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_MIME_TYPE:
      'Bitte wähl eines dieser Bildformate: JPG, PNG oder BMP',
    NBA_CREATE_PHOTO_CARD_IMAGE_UPLOAD_REJECTED_SIZE:
      'Bitte wähl ein Bild mit weniger als 20 MB Dateigröße.',
    NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MAX: 'Max.',
    NBA_CREATE_PHOTO_CARD_IMAGE_ZOOM_MIN: 'Min.',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_HEADLINE: 'Profilbild',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_SIZES:
      'Empfohlene Auflösung: 1024 x 1024 px',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_HINT_FILE_TYPES:
      'JPG, BMP, PNG (max. 20 MB)',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_CLICK: 'Bild hochladen',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OPTION_DRAG_N_DROP:
      'Bild hierhin ziehen',
    NBA_CREATE_PHOTO_CARD_LIGHTBOX_UPLOAD_TEXT_OR: 'oder',
    NBA_CREATE_PHOTO_CARD_SUCCESS_BENEFIT_TEXT:
      'Du kannst dieses Bild jederzeit in Deiner Visitenkarte ändern.',
    NBA_CREATE_PHOTO_CARD_SUCCESS_HEADLINE:
      'Prima, Du hast nun ein neues Profilbild!',
    NOTE_REGISTER_USER_NAME:
      'Wichtig: Dein Benutzername muss mindestens 3 Zeichen lang sein und darf weder Leerzeichen noch folgende Symbole enthalten: + @ :',
    NOTIFICATION_CENTER_LINK: 'Mitteilungen',
    OPTIONS_DELETE: 'Ja, bitte löschen.',
    PASSWORD_RESET_REQUEST_LIMIT_REACHED:
      'Du hast leider zu häufig versucht, Dein Passwort zu erneuern. Bitte versuch es in zwölf Stunden noch einmal.',
    PASSWORD_RESET_UNKNOWN_CREDENTIALS:
      'Diesen Zugang kennen wir leider nicht.',
    PASSWORDHTML_EXPLANATION:
      'Gib hier die E-Mail-Adresse an, an die Du Benachrichtigungen von XING erhalten möchtest. Wir schicken Dir dann einen Link zu, mit dem Du ein neues Passwort einrichten kannst.<br>\n<a href="/help/hilfe-fragen-und-antworten-2/allgemeines-55/registrieren-einloggen-808" target="_blank">Weitere Hilfe zum Einloggen</a>',
    PASSWORDHTML_HEADLINE: 'Probleme mit dem Passwort',
    PASSWORDHTML_NEW_PASSWORD_HEAD: 'Neues Passwort erstellen',
    PASSWORDHTML_OR: 'oder',
    PASSWORDHTML_PASSWORD_SENT:
      'Dein Passwort wurde geändert. Du kannst Dich jetzt mit Deinem neuen Passwort einloggen.',
    PASSWORDHTML_REQUEST_SENT:
      'Bitte schau in Deinen Posteingang: Wir haben Dir eine E-Mail an Deine bei XING hinterlegte E-Mail-Adresse geschickt. Wenn Du auf den Link in der E-Mail klickst, wirst Du auf eine Seite weitergeleitet, auf der Du Dein neues Passwort erstellen kannst.<br><br>\n<strong>Keine Mail zu sehen?</strong> Dann schau bitte auch, ob unsere Mail versehentlich im Spam-Ordner (statt im Posteingang) gelandet ist. Wenn Du nach 2 Stunden noch immer keine Mail erhalten hast, <a href="/app/user?op=support">melde sich gern bei uns</a>.',
    PASSWORTHTML_LIMIT_REACHED:
      'Wir konnten Dir die Informationen zur Erstellung eines neuen Passworts leider nicht zusenden. Bitte  <a href="/app/user?op=support">meld Dich bei uns</a>.',
    PASSWORTHTML_LIMIT_REACHED_GENERIC:
      'Wir konnten Dir die Informationen zur Erstellung eines neuen Passworts leider nicht zusenden. Bitte  <a href="{url_prefix}/app/user?op=support">melden Dich bei uns</a> dazu.',
    PASSWORTHTML_USER_UNKNOWN:
      'Deine Eingabe wurde leider nicht erkannt. Bitte gib Deine E-Mail-Adresse oder Deinen Benutzernamen erneut ein und achte auf korrekte Schreibweise.<br><br>\n<strong>Tipp:</strong> Wenn Du nicht sicher bist, mit welcher E-Mail-Adresse Du bei XING registriert bist, prüf einfach, an welche Adresse XING Dir Nachrichten (z. B. den Newsletter) schickt. Gib diese Adresse dann hier ein.',
    PASSWORTHTML_USER_UNKNOWN_SHORT:
      'Wir haben Deine Eingabe gerade leider nicht erkannt. Kannst Du Deine Zugangsdaten zur Sicherheit bitte nochmal eingeben?',
    PASSWORTHTML_USER_UNKNOWN_WITH_PHONE:
      'Wir haben Deine Eingabe leider nicht erkannt – vielleicht vertippt? Bitte gib Deine E-Mail-Adresse oder Deine Handynummer noch einmal ein.<br><br>\n<strong>Tipp:</strong> Wenn Du nicht sicher bist, mit welcher E-Mail-Adresse Du bei XING registriert bist, prüf einfach, an welche Adresse XING Dir Nachrichten (z. B. den Newsletter) schickt. Gib diese Adresse dann hier ein.',
    PM_UNSAFE_PW_CHANGE_NOW: 'Jetzt Passwort ändern!',
    PM_UNSAFE_PW_HINT_4:
      'Dein Passwort sollte mindestens aus zehn Zeichen bestehen, Groß- und Kleinbuchstaben sowie Zahlen und\nSonderzeichen enthalten.',
    PM_UNSAFE_PW_HOW_TO_CHANGE:
      'Wie erstelle ich ein möglichst sicheres Passwort?',
    'POLLS_TIME_REMAINING_DAYS_WEB.one': 'Endet morgen',
    'POLLS_TIME_REMAINING_DAYS_WEB.other': 'Endet in {days} Tagen',
    'POLLS_TIME_REMAINING_DAYS_WEB.zero': 'Endet heute',
    POLLS_VOTE_ERROR:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    'POLLS_VOTES_NUMBER_WEB.one': '1 Stimme',
    'POLLS_VOTES_NUMBER_WEB.other': '{votes} Stimmen',
    'POLLS_VOTES_NUMBER_WEB.zero': 'Keine Stimmen',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_BODY:
      'Schau Dir alle Event-Teilnehmenden direkt in ProBusiness an, verfeinere die Liste mit zahlreichen Filtern und speicher relevante Leads gleich ab.',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_BUTTON:
      'Teilnahmeliste in ProBusiness ansehen',
    PROBUSINESS_BANNER_EVENTS_GUESTLIST_HEADLINE:
      'Du möchtest Leads aufgabeln?',
    PROBUSINESS_BANNER_SEARCH_BODY:
      'Sieh Dir diese Ergebnisse direkt in ProBusiness an, nutz die effizienten Filtermöglichkeiten und speicher gefundene Kontakte gleich als relevante Leads ab.',
    PROBUSINESS_BANNER_SEARCH_BUTTON: 'Ergebnisse in ProBusiness anzeigen',
    PROBUSINESS_BANNER_SEARCH_HEADLINE:
      'Vertriebsgeheimnis: Verfeinere Deine Ergebnisse!',
    PROBUSINESS_DROPDOWN_SHOW_RESULT: 'In ProBusiness ansehen',
    PROBUSINESS_NO_STATUS_AVAILABLE: 'Lead-Status derzeit unbekannt',
    PROBUSINESS_SAVE_AS_LEAD: 'Lead merken',
    PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_HEADLINE: 'Ambassador·innen',
    PROFILE_BADGES_LAYER_AMBASSADOR_COMMON_TEXT:
      'Ambassador·innen moderieren die offiziellen XING Gruppen und\norganisieren die offiziellen XING Events. Sie haben dabei einen von drei verschiedenen Schwerpunkten:',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_HEADLINE:
      'Branchen-Ambassador·innen',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_LINK: 'Branchen-Gruppen ansehen',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_SUB:
      'Moderator·innen und ausgewiesene Fachleute ihrer Branche',
    PROFILE_BADGES_LAYER_AMBASSADOR_INDUSTRY_TEXT:
      'Branchen-Ambassador·innen sind\nengagierte XING Mitglieder mit einer spezielle Lizenz im\nRahmen unseres Ambassador-Programms. \nSie moderieren jeweils eine große Branchen-Gruppe, verfügen\nüber Fachwissen und Anerkennung in ihrem Fachgebiet\nund unterstützten die Aktivitäten der Mitglieder ihrer Gruppe\nsowohl online als auch durch offizielle Events.',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_HEADLINE:
      'Regional-Ambassador·innen',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_LINK: 'Regional-Gruppen ansehen',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_SUB:
      'Offizieller Event-Veranstalter und Vertrauensperson vor Ort',
    PROFILE_BADGES_LAYER_AMBASSADOR_REGIONAL_TEXT:
      'Regional-Ambassador·innen sind Markenbotschafter·innen und regionaler Anlaufpunkt für XING Mitglieder und Interessierte. Sie moderieren jeweils eine offizielle Regional-Gruppe, veranstalten regelmäßig Events in ihrer\nRegion und unterstützen den Austausch der Gruppen-Mitglieder untereinander.',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_HEADLINE: 'Themen-Ambassador·innen ',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_LINK: 'Themen-Gruppen ansehen',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_SUB:
      'Expert·innen für Themen rund um die moderne Arbeitswelt',
    PROFILE_BADGES_LAYER_AMBASSADOR_TOPIC_TEXT:
      'Dies sind Spezialisten für die moderne\nArbeitswelt. In ihren Gruppen begleiten sie Diskussionen rund\num das Thema "Arbeit der Zukunft". Sie organisieren\nVeranstaltungen, in denen es um neue Trends, Erkenntnisse\nund Meinungen zur Arbeitswelt von heute und morgen geht.',
    PROFILE_BADGES_LAYER_MODERATOR_SUB:
      'Ansprechperson und Konfliktlöser einer Gruppe',
    PROFILE_BADGES_LAYER_PREMIUM_LINK: 'Alle Premium-Vorteile im Überblick',
    PROFILE_BADGES_LAYER_PREMIUM_SUB:
      'Hilfreiche Zusatzfunktionen für Beruf, Karriere und Geschäft',
    PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR: 'Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_AMBASSADOR_TEXT: 'Was ist ein Ambassador?',
    PROFILE_BUSINESS_CARD_BADGE_BASIC: 'Basis',
    PROFILE_BUSINESS_CARD_BADGE_BASIC_TOOLTIP: 'Premium kennenlernen',
    PROFILE_BUSINESS_CARD_BADGE_INDUSTRY_AMBASSADOR: 'Branchen-Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_MODERATOR: 'Moderator',
    PROFILE_BUSINESS_CARD_BADGE_MODERATOR_TEXT: 'Was ist ein Moderator?',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM: 'Premium',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TEXT:
      'Welche Vorteile hat die<br>Premium-Mitgliedschaft?',
    PROFILE_BUSINESS_CARD_BADGE_PREMIUM_TOOLTIP: 'Premium-Mitglied',
    PROFILE_BUSINESS_CARD_BADGE_REGIONAL_AMBASSADOR: 'Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_TOPIC_AMBASSADOR: 'Themen-Ambassador',
    PROFILE_BUSINESS_CARD_BADGE_XPERT: 'Xpert',
    PROFILE_BUSINESS_CARD_BADGE_XPERT_TEXT: 'Was ist ein Xpert?',
    PROFILE_EMAILCHANGE_HEADER: 'Bitte bestätige Deine E-Mail-Adresse.',
    PROFILE_EMAILS_CONFIRMATION_BOUNCE:
      "Die Bestätigung Deiner Benachrichtigungs-Adresse '{-email}' konnte nicht durchgeführt werden, weil die Bestätigungs-E-Mail nicht zugestellt werden konnte. Bitte überprüf hier Deine Eingabe und lass Dir eine erneute Bestätigungs-E-Mail senden.",
    PROFILE_EMAILS_CONFIRMATION_INFO:
      "Wir haben Dir eine Bestätigungs-E-Mail an '{-email}' gesendet. Bitte ruf die Nachricht ab und klick auf den Bestätigungs-Link. Nach erfolgreicher Bestätigung wird diese Adresse aktiviert und Du kannst Dich wieder bei XING einloggen. Wenn Du einen Fehler bei der Eingabe der E-Mail-Adresse gemacht hast, kannst Du ihn im unten stehenden Feld korrigieren.",
    PROFILE_EMAILS_CONFIRMATION_INFO2:
      'Deine aktive Benachrichtigungs-Adresse ist noch nicht bestätigt. \nNach erfolgreicher Bestätigung wird diese Adresse aktiviert und \nDu kannst Dich wieder bei XING einloggen. Wenn Du die Nachricht \nnicht bekommen hast oder bei der Eingabe einen Fehler gemacht \nhast, kannst Du Dir die Bestätigungs-E-Mail hier neu \nzuschicken lassen.',
    PROFILE1HTML_NEW_CONF: 'Neues Passwort zur Bestätigung',
    PROFILE1HTML_NEW_PASSWORD: 'Neues Passwort',
    PROGRESS_BAR_LOADING_PERCENTAGE: '{percentage} % hochgeladen',
    REMEMBER_PASSWORD: 'Eingeloggt bleiben',
    REMINDER_UNDESIRED_USER:
      '<p>Liebes Mitglied,</p><br/><br />\n\n<p>wir möchten Dich darauf hinweisen, dass Dein Profil vorübergehend gesperrt wurde. Derartige Sperrungen können sowohl manuell, als auch automatisiert erfolgen.</p>\n\n<p>Wie kann ich mein XING Profil wieder entsperren?</p>\n\n<p>Dein Profil kann nur nach ausdrücklicher Prüfung durch die New Work SE wieder entsperrt werden. Wir bitten Dich, uns zur Klärung des Sachverhaltes unter der E-Mail Adresse de-quality@xing.com  zu kontaktieren. Wichtig: Bitte kontaktier uns hierfür von der im Profil hinterlegten E-Mail Adresse, damit wir eine schnelle Bearbeitung Deines Anliegens gewährleisten können.</p>\n\n<p><strong>Hinweis:</strong> Während der Sperrung sind die Funktionen auf XING für Dich leider nicht nutzbar.</p>\n\n<p>Gründe, die zu Deiner Sperrung geführt haben können:</p>\n\n<p>… der Verdacht auf Zugriff durch Dritte auf Dein Konto</p> \n<p>… die Verwendung eines Pseudonyms oder eines durch uns noch nicht verifizierten Künstlernamens</p>\n<p>… die Verwendung mehrerer Profile auf XING</p>\n<p>… die Erstellung eines nicht personenbezogenes Profils (Bsp. Unternehmensprofil)</p> \n<p>… ein nicht mehr aktueller Berufseintrag auf Deiner Visitenkarte und/oder die Angabe einer nicht mehr gültigen, geschäftlichen E-Mail-Adresse</p>\n<p>… die Versendung von Spam</p>\n<p>... die mehrfache Veröffentlichung gleichlautender Inhalte in einer oder mehreren Gruppen (Crossposting)</p>\n<p>… die Bewerbung und Förderung von Strukturvertriebsmaßnahmen, wie z. B. Multilevel-Marketing</p> \n<p>… die Nutzung von Mechanismen, Software oder Scripts, die nicht im Rahmen der auf den XING Websites angebotenen Dienste von XING zur Verfügung gestellt werden.</p>\n<p>… die Überschreitung der Nutzung verschiedener Services auf XING</p> \n\n<p>Bitte hab Verständnis, dass wir diese Maßnahme ergreifen, um die Seriosität und die Sicherheit der Plattform zu gewährleisten und generell – auch in Deinem Interesse – Missbrauch vorzubeugen. Solltest Du über eine kostenpflichtige Mitgliedschaft verfügen, wird diese ab dem Zeitpunkt der Sperrung automatisch gestoppt.</p>\n\n<p>Uns ist bewusst, dass dieser Schritt mit Unannehmlichkeiten für Dich verbunden ist, bitten jedoch um Dein Verständnis und danken Dir vorab für die Kooperation.</p>\n\n\n<p>Dein XING Team</p>',
    SE_ALL_VIEW_SEARCH_RESULTS: '{max} Ergebnisse (von {total})',
    SE_EXTENDED_SEARCH_LIST_DESCRIPTION: 'Erweiterte Suche im Bereich ...',
    SE_FILTER_JOBS_PROJOB_LABEL: 'Jobs von Top-Recruitern',
    SE_JOBS_SUGGESTED_NAME_LOCATION: 'Jobs in {location}',
    SE_LABEL_COMMUNITIES: 'Gruppen',
    SE_LABEL_COMPANIES: 'Unternehmen',
    SE_LABEL_EVENTS: 'Events',
    SE_LABEL_JOBS: 'Jobs',
    SE_LABEL_MEMBERS: 'Mitglieder',
    SE_LABEL_NEWS: 'News',
    SE_OFFICIAL_XING_GROUPS: 'Offizielle XING Gruppen',
    SE_PREMIUM_FLAG_ALTTEXT: 'Nur für Premium-Mitglieder',
    SE_SELECT_MEMBERS: 'Mitglieder',
    SE_SHOW_ALL_RESULTS: 'Alle Ergebnisse',
    SEARCH_TOPICS_TAB_SEARCH_BUTTON: 'Suchen',
    SEARCH_TOPICS_TAB_TITLE: 'Themen',
    SETTINGS_MYXS_CURRENT_SESSION_HEADLINE: 'Diese Sitzung',
    SETTINGS_MYXS_HEADLINE: 'Wo bist Du bei XING eingeloggt?',
    SETTINGS_MYXS_INFOTEXT:
      'Hier siehst Du, auf welchen Geräten Du Dich bei XING eingeloggt hast, inkl. Datum und Ort. Das Gerät, das Du jetzt gerade benutzt, ist hervorgehoben. Wenn Dir eines der Geräte verdächtig vorkommt, kannst Du den entsprechenden Login hier einfach beenden.',
    SETTINGS_MYXS_TERMINATE_LINK_TEXT: 'Beenden',
    SETTINGS_MYXS_TEXT_BROWSER: 'Browser:',
    SETTINGS_MYXS_TEXT_LAST_ACCESS: 'Letzter Aufruf am:',
    SETTINGS_MYXS_TEXT_LOGIN_DATE: 'Eingeloggt am:',
    SETTINGS_MYXS_TEXT_LOGIN_LOCATION: 'Eingeloggt in:',
    SETTINGS_MYXS_TEXT_LOGIN_LOCATION_NEAR: 'Ort / Region: {city_name}',
    SETTINGS_MYXS_TEXT_PROVIDER: 'Anbieter:',
    SHARE_ACTIONSHEET_HEADER: 'Diesen Beitrag teilen',
    SHARE_BOX_DEFAULT_ERROR_MESSAGE:
      'Das hat leider nicht geklappt. Bitte versuch es noch einmal.',
    SHARE_BOX_HEADER: 'Auf XING teilen',
    SHARE_BOX_PLACEHOLDER: 'Hier kannst Du Deinen Link kommentieren.',
    SHARE_BOX_SHARE_SUCCESS: 'Vielen Dank fürs Teilen!',
    SHARE_BOX_SUBMIT_SHARE: 'Teilen',
    SHARE_BUTTON_LABEL: 'Teilen',
    SHARE_CANCEL_BUTTON: 'Abbrechen',
    SHARE_CHAT_CONTACTS: 'Kontakt auswählen',
    SHARE_CHAT_HINT: 'Die Empfänger erhalten einzelne Nachrichten.',
    SHARE_COUNTER_LABEL:
      '{counter, plural,\n    =1 {Einmal geteilt}\n    other {#-mal geteilt}\n}',
    SHARE_FEEDBACK_GROUPS_BUTTON: 'Beitrag ansehen',
    SHARE_FEEDBACK_GROUPS_MESSAGE: '{item} in der Gruppe {group} geteilt',
    SHARE_FEEDBACK_INSIDERARTICLE_LABEL: 'Artikel',
    SHARE_FEEDBACK_JOB_LABEL: 'Job',
    SHARE_FEEDBACK_KLARTEXT_LABEL: 'Beitrag',
    SHARE_FEEDBACK_LINK_LABEL: 'Link',
    SHARE_FEEDBACK_MESSENGER_BUTTON: 'Nachricht ansehen',
    SHARE_FEEDBACK_MESSENGER_MESSAGE: '{item} per XING Nachricht geteilt',
    SHARE_FEEDBACK_NEWS_LABEL: 'Artikel',
    SHARE_FEEDBACK_PICTURE_LABEL: 'Bild',
    SHARE_FEEDBACK_POST_LABEL: 'Beitrag',
    SHARE_FEEDBACK_STARTPAGE_BUTTON: 'Beitrag ansehen',
    SHARE_FEEDBACK_STARTPAGE_MESSAGE: '{item} auf der Startseite geteilt',
    SHARE_FEEDBACK_VIDEO_LABEL: 'Video',
    SHARE_FETCH_ERROR: 'Das hat leider nicht geklappt.',
    SHARE_FETCH_ERROR_COUNTDOWN:
      "Wir versuchen's in {countdown} Sekunden noch einmal.",
    SHARE_FETCH_ERROR_RETRY: 'Jetzt erneut versuchen',
    SHARE_MOST_RECENT_CHATS: 'Unterhaltungen',
    SHARE_PREVIEW_ERROR_HEADLINE:
      'Wir können gerade leider keine Vorschau zeigen.',
    SHARE_QUICKSHARE_TO_STARTPAGE: 'Direkt auf der Startseite',
    SHARE_TEXT_BOX_LENGTH_ERROR:
      '{delta, plural, \none {Bitte gib ein Zeichen weniger ein.} \nother {Bitte gib # Zeichen weniger ein.}\n}',
    SHARE_TO_GROUPS: 'In einer Gruppe',
    SHARE_TO_GROUPS_AUTOCOMPLETE_FORUMS: 'Forum',
    SHARE_TO_GROUPS_AUTOCOMPLETE_GROUPS: 'Gruppe',
    SHARE_TO_GROUPS_SELECTION_LABEL: 'Gruppe auswählen:',
    SHARE_TO_GROUPS_TEXT_PLACEHOLDER:
      'Hier kannst Du Deinen Link kommentieren.',
    SHARE_TO_GROUPS_THREAD_LABEL: 'Dein Gruppen-Beitrag:',
    SHARE_TO_GROUPS_TITLE_PLACEHOLDER: 'Beitragstitel',
    SHARE_TO_MESSENGER: 'Als private Nachricht',
    SHARE_TO_MESSENGER_EMPTY_STATE:
      'Wir haben leider keinen "{query}" gefunden.',
    SHARE_TO_STARTPAGE: 'Mit Anmerkung auf der Startseite',
    SHARE_USER_SUBTEXT_GROUPS: 'In einer Gruppe teilen',
    SHARE_USER_SUBTEXT_MESSAGE: 'Als private Nachricht teilen',
    SHARE_USER_SUBTEXT_STARTPAGE: 'Auf der Startseite teilen',
    SHARER_LIST_HEADLINE_MEMBERS: '{total} Mitglieder haben dies geteilt.',
    SHARER_LIST_HEADLINE_MULTIPLE_MEMBERS:
      '{total} Mitglieder haben dies geteilt.',
    SHARER_LIST_HEADLINE_ONE_MEMBER: 'Ein Mitglied hat dies geteilt.',
    SHARER_LIST_ITEM_GO_TO_POST_LINK: 'Beitrag ansehen',
    SHARER_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.',
    SHARERS_BACK_TO_POST_LINK: 'Zurück',
    SHARERS_LIST_BACK_LINK: 'Zurück',
    SOCIAL_ADD_CONTACT: 'Kontakt-Anfrage schicken',
    SOCIAL_BAR_VIEW_COUNTER_DESCRIPTION:
      'Das zeigt Dir ab sofort immer der Zähler neben dem Augen-Symbol.',
    SOCIAL_BAR_VIEW_COUNTER_HEADING:
      'Wie oft wurde Dein Beitrag auf XING gesehen?',
    SOCIAL_BAR_VIEW_COUNTER_SEEN:
      'Dieser Beitrag von Dir wurde z. B. schon <strong>{views}-mal</strong> gesehen.',
    SOCIAL_BAR_VIEW_COUNTER_TIP:
      '<strong>Tipp:</strong> Mit ein paar Kniffen kannst Du <a>Deine Sichtbarkeit auf XING erhöhen</a>.',
    SOCIAL_COMMENT_BUTTON_LABEL: 'Kommentieren',
    SOCIAL_COMMENT_COUNTER_LABEL: '{amount} Kommentare',
    SOCIAL_COMMENT_CREATE_BUTTON_LABEL: 'Kommentieren',
    SOCIAL_COMMENT_DELETE_LABEL: 'Kommentar löschen',
    SOCIAL_COMMENT_DELETED_MESSAGE: 'Dieser Kommentar wurde gelöscht.',
    SOCIAL_COMMENT_EDIT_LABEL: 'Kommentar bearbeiten',
    SOCIAL_COMMENT_ERROR_TOO_LARGE:
      'Dieser Kommentar ist leider zu lang: Bis zu 20 Tsd. Zeichen sind erlaubt.',
    SOCIAL_COMMENT_LIST_EMPTY_HEADLINE: 'Und was meinst Du dazu?',
    SOCIAL_COMMENT_LIST_EMPTY_SUBLINE: 'Verrate uns Deine Meinung.',
    SOCIAL_COMMENT_OVERFLOW_ERROR: '{amount} Zeichen',
    SOCIAL_COMMENT_REPORT_LABEL: 'Kommentar melden',
    SOCIAL_COMMENT_WAS_EDITED: 'Bearbeitet',
    SOCIAL_COMMENTS_COUNTER_LABEL:
      "{counter, plural,\n    =0 {Kommentier's als erstes:}\n    =1 {1 Kommentar} \n    other {# Kommentare}\n}",
    SOCIAL_COMMENTS_CREATE_MENTION_PLACEHOLDER:
      'Etwas schreiben (andere mit "@" erwähnen) …',
    SOCIAL_COMMENTS_CREATE_PLACEHOLDER: 'Schreibe einen Kommentar …',
    SOCIAL_COMMENTS_DELETE_DIALOG_CANCEL: 'Abbrechen',
    SOCIAL_COMMENTS_DELETE_DIALOG_CONFIRM: 'Löschen',
    SOCIAL_COMMENTS_DELETE_DIALOG_CREATOR_TEXT:
      'Nicht zufrieden mit Deinem Kommentar? Dann kannst Du ihn einfach löschen.',
    SOCIAL_COMMENTS_DELETE_DIALOG_HEADLINE: 'Kommentar löschen?',
    SOCIAL_COMMENTS_DELETE_DIALOG_TEXT:
      'Dies kann nicht mehr rückgängig gemacht werden.',
    SOCIAL_COMMENTS_DELETE_MENTION_LABEL: 'Nicht erwähnt werden',
    SOCIAL_COMMENTS_FORM_PLACEHOLDER: 'Etwas schreiben ( mit "@" erwähnen) …',
    SOCIAL_COMMENTS_LOAD_MORE: 'Weitere Kommentare',
    SOCIAL_COMMENTS_MORE_REPLIES: 'Weitere Antworten ansehen',
    SOCIAL_COMMENTS_PREVIOUS_COMMENTS: 'Vorherige Kommentare ansehen',
    SOCIAL_COMMENTS_PREVIOUS_REPLIES: 'Vorherige Antworten ansehen',
    SOCIAL_COMMENTS_REPLY_PLACEHOLDER: 'Deine Antwort an {authorName}',
    SOCIAL_GENERIC_REPORT: 'Melden',
    SOCIAL_LIKERS_LIST_HEADLINE: 'Diesen Mitgliedern gefällt das:',
    SOCIAL_LIKERS_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle "Gefällt mir"-Angaben sehen, weil einige Mitglieder das in ihren Privatsphäre-Einstellungen so festgelegt haben.',
    SOCIAL_PMBX_COMMENT_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_COMMENT_DATE: 'Datum',
    SOCIAL_PMBX_COMMENT_HEADING: 'Deine Kommentare und Antworten',
    SOCIAL_PMBX_COMMENT_MESSAGE: 'Dein Kommentar',
    SOCIAL_PMBX_COMMENT_ORIGIN: 'Wo hast Du kommentiert?',
    SOCIAL_PMBX_COMMENT_TITLE: 'Deine Kommentare und Antworten',
    SOCIAL_PMBX_COMMENT_USER_AGENT: 'System-Info',
    SOCIAL_PMBX_DESCRIPTION:
      'Beiträge auf XING, die Du geteilt, kommentiert, erwähnt oder mit "Gefällt mir" markiert hast',
    SOCIAL_PMBX_REACTION_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_REACTION_DATE: 'Datum',
    SOCIAL_PMBX_REACTION_LIKE: 'Beiträge, die Dir gefallen.',
    SOCIAL_PMBX_REACTION_ORIGIN: 'Wo hast Du auf den Beitrag reagiert?',
    SOCIAL_PMBX_REACTION_TITLE: 'Beiträge, auf die Du reagiert hast',
    SOCIAL_PMBX_REACTION_USER_AGENT: 'User Agent',
    SOCIAL_PMBX_SHARE_CONTENT_URL: 'Inhalt',
    SOCIAL_PMBX_SHARE_DATE: 'Datum',
    SOCIAL_PMBX_SHARE_GROUPS: 'Beiträge, die Du in einer Gruppe geteilt hast',
    SOCIAL_PMBX_SHARE_MESSAGE: 'Deine Anmerkung',
    SOCIAL_PMBX_SHARE_MESSENGER:
      'Beiträge, die Du als private Nachricht geteilt hast',
    SOCIAL_PMBX_SHARE_ORIGIN: 'Wo hast Du den Beitrag geteilt?',
    SOCIAL_PMBX_SHARE_STARTPAGE:
      'Beiträge, die Du auf der XING Startseite geteilt hast',
    SOCIAL_PMBX_SHARE_TITLE: 'Beiträge, die Du geteilt hast',
    SOCIAL_PMBX_SHARE_USER_AGENT: 'User Agent',
    SOCIAL_PMBX_TITLE: 'Interaktionen',
    SOCIAL_REPLIES_LOAD_MORE: 'Weitere Antworten ansehen',
    SOCIAL_REPLY_BUTTON: 'Antworten',
    SOCIAL_REPLY_DISCARD_MESSAGE:
      'Dann kannst Du ihn löschen. Vielleicht schreibst Du ja beim nächsten Mal was.',
    SOCIAL_REPLY_LOAD_MORE: 'Weitere Antwort ansehen',
    SOCIAL_REPLY_LOAD_MULTIPLE: 'Weitere Kommentare ansehen',
    SOCIAL_REPLY_POST_BUTTON: 'Antworten',
    SOCIAL_SEND_MESSAGE: 'Nachricht schreiben',
    SOCIAL_SHARE_COUNTER_LABEL: '{amount}-mal geteilt',
    SOCIAL_SHARE_EXTERNAL_LINK_ERROR:
      'Dieser Link funktioniert leider nicht – deshalb kannst Du ihn nicht teilen.',
    SOCIAL_SHARERS_LIST_HEADLINE_MEMBERS: 'Diese Mitglieder haben das geteilt:',
    SOCIAL_SHARERS_LIST_ITEM_GO_TO_POST_LINK: 'Beitrag ansehen',
    SOCIAL_SHARERS_LIST_POST_NOTIFICATION:
      'Du kannst hier nicht alle Beiträge sehen, weil einige Mitglieder das in ihren Privatphäre-Einstellungen so festgelegt haben.',
    SOCIAL_SHOW_MORE: 'Weiterlesen',
    SOCIAL_SOCIAL_PROOF_LABEL:
      '{counter, plural,\n    =1 {gefällt das:}\n    other {# gefällt das:}\n}',
    SOCIAL_UPDATE_COMMENT_LABEL: 'Speichern',
    SYSM_TFA_DISABLED_EMAIL_HEADER:
      'Dein zweistufiger Login wurde deaktiviert.',
    SYSM_TFA_DISABLED_EMAIL_LIST_1:
      'Du hast ihn selbst in Deinen Einstellungen bei XING deaktiviert.',
    SYSM_TFA_DISABLED_EMAIL_LIST_2: 'Du hast Deinen Ersatzcode genutzt.',
    SYSM_TFA_DISABLED_EMAIL_LIST_3: 'Du hast uns um die Deaktivierung gebeten.',
    SYSM_TFA_DISABLED_EMAIL_LIST_4:
      'Du hast uns um die Änderung Deiner Zugangsdaten gebeten.',
    SYSM_TFA_DISABLED_EMAIL_PARAGRAPH_1: 'Das kann folgende Gründe haben:',
    SYSM_TFA_DISABLED_EMAIL_PARAGRAPH_2:
      'Passt keiner dieser Gründe? Dann meld Dich bitte bei uns.\nÜbrigens: Du kannst den zweistufigen Login jederzeit wieder in Deinen XING Einstellungen aktivieren.',
    SYSM_TFA_DISABLED_EMAIL_PREHEADER:
      'Du kannst ihn jederzeit gern wieder aktivieren.',
    SYSM_TFA_DISABLED_EMAIL_SUBJECT:
      'Dein zweistufiger Login für XING wurde deaktiviert.',
    SYSM_TFA_EMAIL_CONTACT_LINK: 'Zum Kontaktformular',
    SYSM_TFA_ENABLED_EMAIL_HEADER: 'Dein zweistufiger Login ist nun aktiviert.',
    SYSM_TFA_ENABLED_EMAIL_PARAGRAPH_1:
      'Deine Daten bei XING sind nun noch besser geschützt.',
    SYSM_TFA_ENABLED_EMAIL_PARAGRAPH_2:
      'Hast Du den zweistufigen Login nicht aktiviert? Dann meld Dich bitte bei uns:',
    SYSM_TFA_ENABLED_EMAIL_PARAGRAPH_3:
      'Hast Du den zweistufigen Login nicht aktiviert? ',
    SYSM_TFA_ENABLED_EMAIL_PARAGRAPH_4: 'Dann meld Dich bitte bei uns:',
    SYSM_TFA_ENABLED_EMAIL_PREHEADER:
      'Deine Daten bei XING sind nun noch besser geschützt.',
    SYSM_TFA_ENABLED_EMAIL_SUBJECT:
      'Dein zweistufiger Login für XING ist aktiviert.',
    TFA_DISABLED_NOTIFICATION_SMS:
      'Der zweistufige Login wurde für Deinen XING Account deaktiviert.',
    TFA_ENABLED_NOTIFICATION_SMS:
      'Der zweistufige Login wurde für Deinen XING Account aktiviert.',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL: 'Zurück',
    TOP_BAR_BACK_BUTTON_ARIA_LABEL_CUSTOM: 'Zurück zu {section}',
    TOP_BAR_ME_MENU_DIMMER_ARIA_LABEL: 'MeMenü schließen',
    TOP_BAR_PROFILE_FILLING_INDICATOR_TITLE: 'Profil',
    TSV_DISABLE: 'Zweistufige Bestätigung deaktivieren',
    TSV_DISABLE_VERIFY_WITH_PASSWORD:
      'Bitte gib Dein Passwort ein, um die zweistufige Bestätigung zu deaktivieren.',
    TSV_ENABLE: 'Zweistufige Bestätigung aktivieren',
    TSV_FAILED: 'Dieser Code stimmt leider nicht ... vielleicht vertippt?',
    TSV_HEADLINE_TWO_STEP_VERIFICATION: 'Zweistufige Bestätigung',
    TSV_HEADLINE_VERIFICATION_CODE: 'Bestätigungscode',
    TSV_IS_DISABLED: 'Deaktiviert',
    TSV_IS_ENABLED: 'Aktiviert',
    TSV_SCAN_QR_AND_VERIFY_CODE:
      'Scanne den QR-Code mit Deiner Authentifizierungs-App ein und bestätige ihn dann mit Deinem Bestätigungscode.',
    TSV_VERIFICATION_CODE: 'Bestätigungscode',
    UNIVERSAL_CAREER_LEVEL_LIST:
      '1. Student·in / Praktikant·in\n2. Berufseinsteiger·in\n3. Mit Berufserfahrung\n4. Manager (mit und ohne Personalverantwortung)\n5. Direktor·in (z. B. Bereichsleitung, VP, SVP)\n6. Geschäftsführer·in (z. B. GF, CEO)',
    UNIVERSAL_WORKEXPERIENCE_DISCIPLINE_LIST:
      '1001. Analyse und Statistik\n1002. Administration, Sachbearbeitung und Verwaltung\n1003. Beratung / Consulting\n4. Controlling und Planung\n1004. Customer Service und Kundenbetreuung\n1005. Einkauf, Materialwirtschaft und Logistik\n1006. Finanzen, Rechnungswesen und Controlling\n1007. Forschung, Lehre und Entwicklung\n1008. Gesundheit, Medizin und Soziales\n1009. Grafik, Design und Architektur\n1010. Ingenieurwesen und technische Berufe\n1011. IT und Softwareentwicklung\n1012. Management und Unternehmensentwicklung\n1013. Marketing und Werbung\n1014. Personalwesen und HR\n1015. PR, Öffentlichkeitsarbeit und Journalismus\n1016. Produktion und Handwerk\n1017. Produktmanagement\n1018. Projektmanagement\n1019. Prozessplanung und Qualitätssicherung\n1020. Recht\n1021. Vertrieb und Handel\n1022. Sonstige Tätigkeitsfelder',
    UPLOADER_ADD_IMAGE: 'Bild hinzufügen',
    UPLOADER_ADD_VIDEO: 'Video hinzufügen',
    UPLOADER_CANCEL_UPLOAD: 'Doch nicht hochladen',
    UPLOADER_ERROR_BODY: 'Können Sie es bitte nochmal versuchen?',
    UPLOADER_ERROR_HEADLINE: 'Das hat leider nicht geklappt.',
    UPLOADER_IMAGE_LOADING_HEADLINE: 'Dein Bild wird hochgeladen ...',
    UPLOADER_TRY_AGAIN: 'Noch einmal versuchen',
    UPLOADER_VIDEO_LOADED_BODY:
      'Wir bereiten es nun auf, damit es in bestmöglicher Qualität abgespielt werden kann. Sie können es aber gerne schon veröffentlichen oder teilen.',
    UPLOADER_VIDEO_LOADED_HEADLINE: 'Ihr Video wurde hochgeladen.',
    UPLOADER_VIDEO_LOADING_HEADLINE: 'Video wird hochgeladen ...',
    USER_FLAG_BUTTON_ARIA_LABEL: 'Markierung für XING {type}',
    USER_FLAG_ERROR:
      "Diese Info können wir gerade leider nicht zeigen.<br>\nVersuch's bitte später nochmal.",
    USER_FLAG_ERROR_PARAGRAPH_1:
      'Diese Info können wir gerade leider nicht zeigen.',
    USER_FLAG_ERROR_PARAGRAPH_2: "Versuch's bitte später nochmal.",
    USER_FLAG_LOADING: 'Einen Moment bitte ...',
    UVP_APP_MESSAGE_INVALID_TOKEN:
      'Leider ist der Link zum Zurücksetzen Deines Passwortes nicht mehr gültig.',
    UVP_APP_MESSAGE_PW_MISMATCH: 'Die Passwörter stimmen nicht überein.',
    UVP_CONFIRM_EMAIL_INVALID_LINK:
      'Dieser Link ist leider nicht mehr gültig. Bitte starte den Prozess erneut.',
    UVP_EMAIL_ACCESS_CONFIRM_LABEL: 'E-Mail-Adresse bestätigen:',
    UVP_EMAIL_ACCESS_DESCRIPTION:
      'Dann gib diese E-Mail-Adresse bitte hier ein.<br>\n<strong>Hinweis für Gmail-Nutzer:</strong> Gib die Endung "gmail.com" oder "googlemail.com" bitte so ein, wie Du es bei Deiner XING Registrierung getan hast.',
    UVP_EMAIL_ACCESS_HEADLINE:
      'Kennst Du Deine E-Mail-Adresse, hast dazu aber keinen Zugang mehr?',
    UVP_EMAIL_ACCESS_LABEL: 'E-Mail:',
    UVP_EMAIL_CONFIRM_MESSAGE_HEADLINE: 'Bitte schau in Deinen Posteingang.',
    UVP_EMAIL_CONFIRM_MESSAGE_TEXT:
      'Wir haben Dir eine E-Mail an Deine neue Wunschadresse geschickt. Wenn Du auf den Link in der E-Mail klickst, wird Dein Änderungswunsch an unseren Kundensupport weitergeleitet.<br><br>\n<strong>Keine Mail zu sehen?</strong> Dann schaubitte auch, ob unsere Mail versehentlich im Spam-Ordner (statt im Posteingang) gelandet ist. Wenn Du nach 2 Stunden noch immer keine Mail erhalten hast, <a href="{support_link}">melde Dich bitte bei uns</a>.',
    UVP_EMAIL_FORM_LABEL: 'E-Mail:',
    UVP_EMAIL_OR_PHONE_ACCESS_DESCRIPTION:
      '<strong>Hast Du Dich mit Deiner E-Mail-Adresse bei XING registriert?</strong> Dann gib diese bitte hier ein.<br>\n(Du erkennst die richtige E-Mail-Adresse daran, dass wir Dir dorthin unsere Benachrichtigungen senden.)<br><br>\n<strong>Hast Du Dich mit Deiner Handynummer bei XING registriert?</strong> Dann gib stattdessen diese bitte hier ein.<br>\n(An diese Handynummer haben wir Dir den XING Aktivierungscode per SMS geschickt.)',
    UVP_EMAIL_OR_PHONE_ACCESS_HEADLINE:
      'Kennst Du Deine E-Mail-Adresse / Handynummer, hast dazu aber keinen Zugang mehr?',
    UVP_EMAIL_OR_PHONE_TAB: 'Kein Zugang zu Deiner E-Mail / Handynr.?',
    UVP_EMAIL_PHONE_FORM_LABEL: 'E-Mail / Handynummer',
    UVP_EMAIL_PROCESS_APPROVED_SUBJECT:
      'Dein XING Profil: Deine neue E-Mail-Adresse wurde bestätigt',
    UVP_EMAIL_PROCESS_APPROVED_TEXT:
      'Deine Login-Daten haben wir nach Deinen Wünschen angepasst.\n\nDu kannst Dich jetzt mit Deiner neuen E-Mail-Adresse einloggen:\n{login_url}',
    UVP_EMAIL_PROCESS_CONFIRM_MAIL_SUBJECT:
      'Bitte bestätige Deine neue E-Mail-Adresse.',
    UVP_EMAIL_PROCESS_CONFIRM_MAIL_TEXT:
      'Wir haben Deine Anfrage zur Änderung Deiner E-Mail-Adresse erhalten.<br>\n<br>\nWenn jemand anders diese Anfrage an uns geschickt hat oder wenn Du wieder Zugriff auf Deine alte E-Mail-Adresse hast, kannst Du diese Nachricht einfach ignorieren und weiterhin Deine alte E-Mail-Adresse benutzen.<br>\n<br>\nWenn Du nun aber eine neue E-Mail-Adresse erstellen möchtest, dann klick bitte auf den folgenden Link:<br>\n{account_reset_link}\n<br>\nSollte der Link nicht funktionieren, kannst Du ihn auch einfach kopieren und manuell in die Adresszeile Deines Browsers einfügen.',
    UVP_EMAIL_PROCESS_DECLINED_SUBJECT:
      'Dein XING Profil: Verifizierung noch nicht vollständig',
    UVP_EMAIL_PROCESS_DECLINED_TEXT:
      'Der Zugriff auf Dein Profil kann nicht gewährt werden. Folgende Gründe können hierfür die Ursache sein:<br>\n<br>\n- Du hast statt eines Dokumentes nur ein Foto Deiner Person übermittelt.<br>\n- Das Geburtsdatum wird auf dem Dokument nicht ausgewiesen.<br>\n- Das Geburtsdatum ist nicht identisch.<br>\n- Du bist auf dem hochgeladenen Dokument nicht eindeutig zu erkennen.<br>\n <br>\nBitte prüfe, ob eine der möglichen Ursachen zutrifft und beachte die Punkte beim erneuten Hochladen eines Dokumentes. Sollte dies nicht der Fall sein, sende uns bitte eine E-Mail an zugang@xing.com und übermittel uns weitere Dir bekannte Angaben aus Deinem Profil, die uns bei einer Verifizierung unterstützen können.<br>\n<br>',
    UVP_EMAIL_RESET_ALERT_SUBJECT:
      'Es wurde versucht, die E-Mail-Adresse für Deinen Account zurückzusetzen.',
    UVP_EMAIL_RESET_ALERT_TEXT:
      'Falls Du selbst versucht hast, Deine E-Mail-Adresse zurückzusetzen, kannst Du diese E-Mail ignorieren.<br>\n<br>\nAndernfalls wende Dich bitte umgehend an unseren Support:<br>\n{support_link}',
    UVP_EMAIL_TAB: 'Kein Zugang zur E-Mail-Adresse?',
    UVP_ENTER_CODE_HERE: 'Code hier eingeben',
    UVP_ENTER_CODE_HERE_DESC:
      '… an das Handy mit der Nummer <strong>{phone}</strong>. Gib den Code aus dieser SMS bitte hier ein, um Dein Passwort zurückzusetzen: ',
    UVP_IDENTITIY_CHECK_SUBMIT: 'Identifikationsdaten senden',
    UVP_IDENTITY_CARD_LABEL: 'Dokument hochladen',
    UVP_IDENTITY_CHECK_DESCRIPTION:
      'Wir möchten nun sicherstellen, dass niemand außer Dir selbst Zugriff auf Deine persönlichen Daten erhält. Dazu bitten wir Dich, Deine Identität zu verifizieren:<br><br>\n<strong>1. Fotografier bitte Deinen Führerschein oder Deine Gesundheitskarte.</strong><br>\nUnd so geht\'s: Einfach auf "Aufnahme erstellen" klicken und den Führerschein / die Gesundheitskarte vor Deiner Web-Kamera halten.<br>\n (Wenn Du keine Web-Kamera hast, speicher das Foto zunächst auf Deinem PC und klick dann auf "Datei auswählen", um es hier hochzuladen.)<br><br>\n <strong>Wichtig:</strong> Das Dokument muss Dein Portraitfoto, Deinen Namen und Dein Geburtsdatum zeigen. (Eventuell musst Du dafür Vor- und Rückseite fotografieren.) Es darf zudem <strong>kein</strong> Foto von Deinem Ausweis oder Pass sein: Wir dürfen diese aus Rechtsgründen nicht empfangen.<br><br>\n\n<strong>2. Gib dann bitte die neue E-Mail-Adresse ein.</strong><br>\nDas ist die E-Mail-Adresse, die Du zukünftig zum Einloggen auf XING verwenden möchtest. Klick zum Schluss auf "Identifikationsdaten senden". ',
    UVP_IDENTITY_CHECK_HEADLINE: 'Verifizierung Deiner Identität',
    UVP_NEW_EMAIL_CONFIRM_LABEL: 'Neue E-Mail-Adresse bestätigen:',
    UVP_NEW_EMAIL_LABEL: 'Neue E-Mail-Adresse:',
    UVP_NEW_EMAIL_PLACEHOLDER: 'Z. B. "heinz.gruendel@neue-adresse.de"',
    UVP_NO_SMS_RECEIVED: 'Keine SMS erhalten? ',
    UVP_PASSWORD_LOST_SUBJECT: 'Dein Zugang zu XING',
    UVP_PASSWORD_LOST_TEXT:
      'Wir haben eine Anfrage auf Zurücksetzung Deines XING Passworts erhalten.<br>\n<br>\nFalls Du diese Anfrage nicht an uns geschickt hast oder Du Dich wieder an Dein altes Passwort erinnerst, kannst Du diese Nachricht ignorieren und weiterhin Dein altes Passwort benutzen.<br>\n<br>\nWenn Du tatsächlich ein neues Passwort erstellen möchtest, stell bitte zunächst sicher, dass in Deinem Browser Cookies für XING zugelassen werden. Klick dann auf den folgenden Link:<br>\n{reset_token_link}\n<br>\nSollte der Link nicht funktionieren, kannst Du ihn auch kopieren und manuell in die Adresszeile Deines Browsers einfügen.',
    UVP_PASSWORD_RESET_SMS_CONFIRM_TEXT:
      '{code} ist der Sicherheitscode zum Zurücksetzen Deines XING Passwortes.',
    UVP_PASSWORD_RESET_SUCCESS_MAIL_SUBJECT:
      'Dein Passwort wurde zurückgesetzt.',
    UVP_PASSWORD_RESET_SUCCESS_MAIL_TEXT:
      'Dein Passwort wurde wunschgemäß zurückgesetzt.\n\nHast Du Dein Passwort gar nicht zurückgesetzt? Dann wenden Dich bitte umgehend an uns:\n{support_link}',
    UVP_PASSWORDHTML_REQUEST_SENT:
      'Bitte schau in Deinen Posteingang: Wir haben Dir eine E-Mail geschickt (sofern diese Adresse bei XING hinterlegt ist). Wenn Du auf den Link in der E-Mail klickst, wirst Du auf eine Seite weitergeleitet, auf der Du Dein neues Passwort erstellen kannst.<br><br>\n<strong>Keine Mail zu sehen?</strong> Dann schau bitte auch, ob unsere E-Mail versehentlich im Spam-Ordner (statt im Posteingang) gelandet ist. Wenn Du nach 2 Stunden noch immer keine Mail erhalten hast, <a href="{support_link}">melde Dich bitte bei uns</a>.',
    UVP_PROFILE_SEARCH_TAB: 'E-Mail-Adresse vergessen?',
    UVP_PROFILE_SEARCH_TAB_WITH_PHONE: 'Zugangsdaten vergessen?',
    UVP_PROFILE_URL_ACCESS_DESCRIPTION:
      '<strong>So erkennst Du Deine bei XING registrierte E-Mail-Adresse:</strong><br>\nPrüfe einfach, an welche E-Mail-Adresse wir Dir Benachrichtigungen senden.<br><br>\n<strong>So erkennst Du Deine bei XING registrierte Handynummer: </strong><br>\nSchau nach, an welche Handynummer wir Dir den Aktivierungscode per SMS geschickt haben.<br><br>\nFalls das alles nicht möglich ist, gib hier bitte zunächst den Link zu Deinem XING Profil ein.<br><br>\n<strong>So findest Du Dein XING Profil:</strong> Such bei Google nach Deinem Namen plus "XING" , also z. B. "Andreas Fischer XING". Wenn das nicht geht, z. B. weil Dein Profil nur für eingeloggte Mitglieder sichtbar ist, bitte einen Deiner XING Kontakte, Dir den Link zu Deinem Profil zukommenzulassen.',
    UVP_PROFILE_URL_ACCESS_DESCRIPTION_WITH_PHONE:
      'Bitte prüfe zunächst, an welche E-Mail-Adressen Du Nachrichten von XING bekommst bzw. an welche Nummer wir Dir eine SMS mit dem Aktivierungscode geschickt haben. Versuch dann, Dich mit dieser Adresse / Handynummer bei XING einzuloggen.<br><br>\nFalls das nicht möglich ist, gib hier bitte zunächst den Link zu Deinem XING Profil ein.<br><br>\n<strong>So findest Du Dein XING Profil:</strong> Suche bei Google nach Deinem Namen plus "XING" , also z. B. "Jürgen Hartmann XING". Wenn das nicht geht, z. B. weil Dein Profil nur für eingeloggte Mitglieder sichtbar ist, bitte einen Deiner XING Kontakte, Dir den Link zu Deinem Profil zukommenzulassen.',
    UVP_PROFILE_URL_ACCESS_HEADLINE:
      'Bist Du unsicher, mit welcher E-Mail-Adresse Du bei XING registriert bist?',
    UVP_PROFILE_URL_ACCESS_HEADLINE_WITH_PHONE:
      'Du bist unsicher, mit welcher E-Mail-Adresse / Handynummer Du bei XING registriert bist?',
    UVP_PROFILE_URL_LABEL: 'Link zum XING Profil:',
    UVP_PROFILE_URL_PLACEHOLDER:
      'Z. B. "https://www.xing.com/profile/Marcus_Berg"',
    UVP_RESET_SMS_SENT: 'Wir haben Dir gerade eine SMS geschickt ...',
    UVP_SMS_WRONG_CODE:
      'Dieser Code ist leider nicht richtig ... vielleicht vertippt? ',
    UVP_STARTPAGE_DESCRIPTION:
      'Wir helfen Dir gerne weiter. Bitte wähle eine dieser beiden Optionen:',
    UVP_STARTPAGE_DESCRIPTION_THREE_OPTIONS:
      'Wir helfen gern weiter. Wähle bitte eine dieser beiden Optionen:',
    UVP_STARTPAGE_FORGOT_EMAIL_CTA: 'Neue E-Mail-Adresse festlegen',
    UVP_STARTPAGE_FORGOT_EMAIL_DESCRIPTION:
      '<strong>Weißt Du nicht, mit welcher E-Mail-Adresse Du bei XING registriert bist?</strong><br>\nPrüfe, an welche E-Mail-Adresse Du Nachrichten von XING erhältst: Das ist die richtige Adresse.<br><br>\n<strong>Hast Du ein anderes Problem?</strong><br>\nDann kannst Du auch eine neue E-Mail-Adresse für XING festlegen. Folge dazu einfach den weiteren Schritten:',
    UVP_STARTPAGE_FORGOT_EMAIL_OR_PHONE_CTA: 'Neue Zugangsdaten festlegen',
    UVP_STARTPAGE_FORGOT_EMAIL_OR_PHONE_DESCRIPTION:
      '<strong>Weißt Du nicht, mit welcher E-Mail-Adresse Du bei XING registriert bist?</strong><br>\n    Prüfe, an welche E-Mail-Adresse Du Nachrichten von XING erhältst: Das ist die richtige Adresse.<br><br>\n<strong>Weißt Du nicht, mit welcher Handynummer Du bei XING registriert bist?</strong><br>\nPrüfe, an welche Nummer Du eine SMS mit dem Aktivierungscode von XING erhalten hast.<br><br>\n    <strong>Hast Du ein anderes Problem?</strong><br>\n    Dann kannst Du auch neue Zugangsdaten für XING festlegen. Folge dazu einfach den weiteren Schritten:',
    UVP_STARTPAGE_FORGOT_PW_CTA: 'Passwort zurücksetzen',
    UVP_STARTPAGE_FORGOT_PW_PLACEHOLDER: 'Z. B. "erik.meijer@beispiel.de"',
    UVP_STARTPAGE_FORGOT_PW_PLACEHOLDER_WITH_PHONE:
      'Z. B. "takahara@example.com" oder "+49175123456789"',
    UVP_STARTPAGE_HEADLINE: 'Hast Du Probleme beim Einloggen?',
    UVP_STARTPAGE_SUPPORT_PAGE_DESCRIPTION:
      'Wir helfen Dir gern persönlich weiter. Schreib uns einfach eine Nachricht und beschreiben Dein Problem so ausführlich wie möglich.',
    UVP_STARTPAGE_SUPPORT_PAGE_HEADLINE:
      'Hast Du ein anderes Problem beim Einloggen in Dein XING Profil?',
    UVP_STARTPAGE_SUPPORT_PAGE_LINK: 'Zum Hilfe-Bereich',
    UVP_USER_CARE_MESSAGE_HEADLINE: 'Vielen Dank für Dein Anfrage.',
    UVP_USER_CARE_MESSAGE_TEXT:
      'Deine Anfrage wird nun von unserer Kundenbetreuung geprüft.',
    UVP_VERIFY_E_MAIL_CONFIRM_MESSAGE:
      'Die beiden E-Mail-Adressen stimmen leider nicht überein. Bitte achte darauf, dass die neue E-Mail-Adresse mit der Bestätigungsadresse identisch ist.',
    UVP_VERIFY_E_MAIL_MESSAGE: 'Gib bitte eine E-Mail-Adresse an.',
    UVP_VERIFY_IMAGE_SIZE_MESSAGE:
      'Das Bild ist leider zu groß. Bitte wähl ein Bild mit einer geringeren Dateigröße aus.',
    UVP_VERIFY_IMAGES_MESSAGE:
      'Bitte lade eines der angegebenen Dokumente hoch – oder erstell davon eine Aufnahme mit Deiner Webcam.',
    UVP_VERIFY_NEW_MAIL_ERROR:
      "Diese E-Mail-Adresse haben wir bereits im System. Bist Du's? Ansonsten wähle bitte eine andere.",
    UVP_VERIFY_NEW_MAIL_OR_PHONE_ERROR:
      'Diese E-Mail-Adresse / Handynummer ist bereits aktiviert – Du kannst hier eine neue festlegen, wenn Du möchtest.',
    UVP_WEBCAM_ERROR_DESCRIPTION:
      'Leider können wir Deine Webcam nicht erkennen. Ist vielleicht kein Adobe Flash Player installiert? Bitte überprüf auch die Sicherheitseinstellungen Deines Browsers und erlaube den Zugriff auf Deine Webcam.',
    UVP_WEBCAM_ERROR_HEADLINE: 'Verbindungsfehler',
    UVP_WEBCAM_SNAPSHOT_CTA: 'Aufnahme erstellen',
    UVP_WEBCAM_SNAPSHOT_LABEL: 'Dokument per Webcam fotografieren:',
    VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS: 'Business-Lösungen',
    VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS_SHORT: 'Business',
    VERTICAL_NAVIGATION_CAMPUS: 'Campus',
    VERTICAL_NAVIGATION_COMMUNITIES: 'Gruppen',
    VERTICAL_NAVIGATION_COMPANIES: 'Unternehmen',
    VERTICAL_NAVIGATION_CONTACTS: 'Dein Netzwerk',
    VERTICAL_NAVIGATION_CONTACTS_SHORT: 'Netzwerk',
    VERTICAL_NAVIGATION_CONTENT_PAGES: 'News',
    VERTICAL_NAVIGATION_EVENTS: 'Eventmarkt',
    VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE:
      'Die neue XING App: Feedback & Hilfe',
    VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE_SHORT: 'Neue App',
    VERTICAL_NAVIGATION_FOOTER_ADVERTISE: 'Werben auf XING',
    VERTICAL_NAVIGATION_FOOTER_AMIANDO: 'Ticketing und Eventvermarktung',
    VERTICAL_NAVIGATION_FOOTER_ANDROID: 'Android',
    VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN: 'Anschreiben-Editor',
    VERTICAL_NAVIGATION_FOOTER_APP_GALLERY: 'Mobile & Desktop Apps',
    VERTICAL_NAVIGATION_FOOTER_APPS: 'Apps',
    VERTICAL_NAVIGATION_FOOTER_BEWERBUNG: 'Bewerbungsratgeber',
    VERTICAL_NAVIGATION_FOOTER_CAMPUS: 'Campus',
    VERTICAL_NAVIGATION_FOOTER_CAREER: 'Karriere',
    VERTICAL_NAVIGATION_FOOTER_CAREER_GUIDE: 'Karriere-Ratgeber',
    VERTICAL_NAVIGATION_FOOTER_COACHES: 'Coaches + Trainer',
    VERTICAL_NAVIGATION_FOOTER_COMMUNITY: 'Community',
    VERTICAL_NAVIGATION_FOOTER_COMPANIES: 'Unternehmen',
    VERTICAL_NAVIGATION_FOOTER_COMPANY: 'Unternehmen',
    VERTICAL_NAVIGATION_FOOTER_DEVBLOG: 'Devblog',
    VERTICAL_NAVIGATION_FOOTER_DEVELOPER_PORTAL: 'Entwickler',
    VERTICAL_NAVIGATION_FOOTER_DOWNLOAD: 'Downloads',
    VERTICAL_NAVIGATION_FOOTER_EVENTS: 'Events',
    VERTICAL_NAVIGATION_FOOTER_GEHALTSVERGLEICH: 'Gehaltsvergleich',
    VERTICAL_NAVIGATION_FOOTER_GROUPS: 'Gruppen',
    VERTICAL_NAVIGATION_FOOTER_HALLO_FREELANCER: 'Freelancer verwalten',
    VERTICAL_NAVIGATION_FOOTER_HELP: 'Hilfe & Kontakt',
    VERTICAL_NAVIGATION_FOOTER_IMPRINT: 'Impressum',
    VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS: 'Investor Relations',
    VERTICAL_NAVIGATION_FOOTER_IPHONE_IPAD: 'iPhone & iPad',
    VERTICAL_NAVIGATION_FOOTER_JOB_MARKET: 'Jobs',
    VERTICAL_NAVIGATION_FOOTER_JOBS_DIRECTORY: 'Jobs Verzeichnis',
    VERTICAL_NAVIGATION_FOOTER_KUNUNU: 'Arbeitgeber-Bewertungen',
    VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF: 'Lebenslauf-Editor',
    VERTICAL_NAVIGATION_FOOTER_LOGINWXING: 'Button "Mit XING einloggen"',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIP_CANCELLATION:
      'Mitgliedschaft kündigen',
    VERTICAL_NAVIGATION_FOOTER_MEMBERSHIPS: 'Mitgliedschaften',
    VERTICAL_NAVIGATION_FOOTER_MOBILE: 'XING Apps',
    VERTICAL_NAVIGATION_FOOTER_NEW_WORK_EXPERIENCE:
      'NWX – Neues zur Zukunft der Arbeit',
    VERTICAL_NAVIGATION_FOOTER_NEWWORKSE: 'New Work SE',
    VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY: 'Mitgliederverzeichnis',
    VERTICAL_NAVIGATION_FOOTER_PRAKTIKUM_GUIDE: 'Praktikum-Guide',
    VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_FOOTER_PRESS: 'Presse',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY: 'Datenschutz bei XING',
    VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY: 'Datenschutzerklärung',
    VERTICAL_NAVIGATION_FOOTER_PRO_BUSINESS_MEMBERSHIP: 'ProBusiness',
    VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_FOOTER_RESOURCES: 'Ressourcen',
    VERTICAL_NAVIGATION_FOOTER_SERVICES: 'Weitere Angebote',
    VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER: 'Personalgewinnung mit XING',
    VERTICAL_NAVIGATION_FOOTER_TANDC: 'AGB',
    VERTICAL_NAVIGATION_FOOTER_TRACKING: 'Tracking',
    VERTICAL_NAVIGATION_FOOTER_WINDOWS_10: 'Windows 10',
    VERTICAL_NAVIGATION_FOOTER_XAS: 'Werbeanzeige erstellen',
    VERTICAL_NAVIGATION_FOOTER_XING_AG: 'New Work SE',
    VERTICAL_NAVIGATION_FOOTER_XING_NEWS: 'XING News',
    VERTICAL_NAVIGATION_FOOTER_XING_SHARE: 'Button "Auf XING teilen"',
    VERTICAL_NAVIGATION_FOOTER_YOUR_XING: 'Hauptbereiche',
    VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR: 'BrandManager',
    VERTICAL_NAVIGATION_HEADER_HELP: 'Hilfe',
    VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS: 'Stellenanzeigen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS: 'AdManager',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE: 'Coach-Profil',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_INVOICES: 'Rechnungen & Konten',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT: 'Ausloggen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_MEMBERSHIPS_INVOICES:
      'Mitgliedschaften & Rechnungen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP: 'Premium',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROBUSINESS_MEMBERSHIP: 'ProBusiness',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP: 'ProJobs',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_SETTINGS:
      'ProJobs-Einstellungen',
    VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS: 'Einstellungen',
    VERTICAL_NAVIGATION_HEADER_SEARCH_ALL_RESULTS: 'Alle Ergebnisse',
    VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON: 'Suchen',
    VERTICAL_NAVIGATION_HEADER_SEARCH_COMMUNITIES: 'Gruppen',
    VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES_PROFILE: 'Arbeitgeber',
    VERTICAL_NAVIGATION_HEADER_SEARCH_EVENTS: 'Events',
    VERTICAL_NAVIGATION_HEADER_SEARCH_JOBS: 'Jobs',
    VERTICAL_NAVIGATION_HEADER_SEARCH_MEMBERS: 'Mitglieder',
    VERTICAL_NAVIGATION_HEADER_SEARCH_NEWS: 'Branchen-News',
    VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER:
      'Job, Namen oder Stichwort eingeben',
    VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN: 'LizenzManager',
    VERTICAL_NAVIGATION_HEADER_XTM: 'TalentManager',
    VERTICAL_NAVIGATION_MESSAGES: 'Nachrichten',
    VERTICAL_NAVIGATION_MORE: 'Mehr',
    VERTICAL_NAVIGATION_MYPROJOBS: 'ProJobs',
    VERTICAL_NAVIGATION_OTHER_SERVICES: 'Weitere Services',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS: 'Premium',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS_FOR_BASIC_USER: 'Premium werden',
    VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT: 'Premium',
    VERTICAL_NAVIGATION_PROBUSINESS: 'ProBusiness',
    VERTICAL_NAVIGATION_PROJOBS_BENEFITS_FOR_BASIC_USER: 'ProJobs werden',
    VERTICAL_NAVIGATION_PROJOBS_UPSELL: 'ProJobs entdecken',
    VERTICAL_NAVIGATION_PROJOBS_UPSELL_SHORT: 'ProJobs',
    VERTICAL_NAVIGATION_STARTPAGE: 'Startseite',
    VIDEO_ENCODING_HEADLINE: 'Ihr Video wird gerade aufbereitet.',
    VIDEO_ENCODING_MESSAGE:
      'Wir bereiten gerade Dein Video so auf, dass wir es in der bestmöglichen Qualität anzeigen können. Dies kann ein paar Minuten dauern.',
    VIDEOS_AUTOPLAY: 'Automatisch abspielen',
    VIDEOS_SETTINGS: 'Videos automatisch abspielen?',
    VIDEOS_WATCH_VIDEO: 'Video ansehen',
    VIEW_PAGE_IN_CHINESE: 'Diese Seite auf Chinesisch anzeigen',
    VIEW_PAGE_IN_DUTCH: 'Diese Seite auf Niederländisch anzeigen',
    VIEW_PAGE_IN_ENGLISH: 'Diese Seite auf Englisch anzeigen',
    VIEW_PAGE_IN_FINNISH: 'Diese Seite auf Finnisch anzeigen',
    VIEW_PAGE_IN_FRENCH: 'Diese Seite auf Französisch anzeigen',
    VIEW_PAGE_IN_GERMAN: 'Diese Seite auf Deutsch anzeigen',
    VIEW_PAGE_IN_HUNGARIAN: 'Diese Seite auf Ungarisch anzeigen',
    VIEW_PAGE_IN_ITALIAN: 'Diese Seite auf Italienisch anzeigen',
    VIEW_PAGE_IN_JAPANESE: 'Diese Seite auf Japanisch anzeigen',
    VIEW_PAGE_IN_KOREAN: 'Diese Seite auf Koreanisch anzeigen',
    VIEW_PAGE_IN_POLISH: 'Diese Seite auf Polnisch anzeigen',
    VIEW_PAGE_IN_PORTUGUESE: 'Diese Seite auf Portugiesisch anzeigen',
    VIEW_PAGE_IN_RUSSIAN: 'Diese Seite auf Russisch anzeigen',
    VIEW_PAGE_IN_SPANISH: 'Diese Seite auf Spanisch anzeigen',
    VIEW_PAGE_IN_SWEDISH: 'Diese Seite auf Schwedisch anzeigen',
    VIEW_PAGE_IN_TURKISH: 'Diese Seite auf Türkisch anzeigen',
    WELCOME_AD_LOADING: 'Deine Startseite wird geladen ...',
    WELCOME_APP_HEADER_LOGIN_PASSWORD_LOST: 'Probleme beim Einloggen?',
    WELCOME_STARTPAGE_PROCEED_WITH_APPLE_BUTTON: 'Weiter mit Apple',
    WELCOME_STARTPAGE_PROCEED_WITH_GOOGLE_BUTTON: 'Weiter mit Google',
    X_UI_HEADER_REGISTER: 'Registrieren',
    X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK: 'Einloggen',
    X_UPGRADE_FEATURE_LINK_LOGGED_OUT:
      'Bitte logg Dich ein, um einen Überblick über die Funktionen zu sehen.',
    XAM_GENERIC_ERROR_MESSAGE:
      "Das hat leider nicht geklappt. Versuchen Sie's bitte noch mal.",
    XAM_LEAD_AD_CUSTOM_QUESTION_PLACEHOLDER: 'Geben Sie hier Ihre Antwort ein.',
    XAM_LEAD_AD_FORM_THANKS_CTA_DOWNLOAD_NOW: 'Jetzt herunterladen',
    XAM_LEAD_AD_FORM_THANKS_CTA_TRY_NOW: 'Jetzt ausprobieren',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_COMPANY_WEBSITE:
      'Zur Unternehmenswebsite',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_NOW: 'Jetzt besuchen',
    XAM_LEAD_AD_FORM_THANKS_CTA_VISIT_XING_PAGE: 'Zur XING Seite',
    XAM_LEAD_AD_PREVIEW_CONFIRMATION_SUCCESS_MESSAGE: 'Anfrage gesendet',
    XAS_ARMSTRONG_LEAD_AD_FORM_THANKS_BUTTON_COPY: 'XING Seite ansehen',
    XBP_NAVIGATION_ENTRY_LINK: 'Business Pages verwalten',
    XDS_A11Y_CHARACTER_COUNTER_MAX: 'Maximum überschritten',
    XDS_A11Y_CHARACTER_COUNTER_TEXT:
      '{currentCount} von {maxCount} Zeichen verwendet',
    XDS_A11Y_LOADING: 'Wird geladen',
    XDS_BACK_TO_TOP_BUTTON: 'Nach oben',
    XDS_BREADCRUMB_HOME: 'Home',
    XDS_CAROUSEL_NEXT_BUTTON_A11Y: 'Nächste Seite',
    XDS_CAROUSEL_PREVIOUS_BUTTON_A11Y: 'Vorherige Seite',
    XDS_CLOSE_BUTTON_A11Y: 'Schließen',
    XDS_DELETE_TAG_BUTTON_A11Y: 'Löschen',
    XDS_DISCOVER_BADGE_A11Y: 'Neue Funktion',
    XDS_EMPTYSTATE_ERROR_BUTTON: 'Noch mal versuchen',
    XDS_EMPTYSTATE_ERROR_DESCRIPTION: "Bitte versuch's noch mal.",
    XDS_EMPTYSTATE_ERROR_TITLE: 'Das hat leider nicht geklappt.',
    XDS_FEEDBACK_BAR_THUMB_DOWN_A11Y: 'Daumen runter',
    XDS_FEEDBACK_BAR_THUMB_UP_A11Y: 'Daumen hoch',
    XDS_FLAG_AMBASSADOR_DIVERSE: 'Ambassadx',
    XDS_FLAG_AMBASSADOR_FEMALE: 'Ambassadorin',
    XDS_FLAG_AMBASSADOR_MALE: 'Ambassador',
    XDS_FLAG_AMBASSADOR_NEUTRAL: 'Ambassador',
    XDS_FLAG_BASIC_DIVERSE: 'Basis',
    XDS_FLAG_BASIC_FEMALE: 'Basis',
    XDS_FLAG_BASIC_MALE: 'Basis',
    XDS_FLAG_BASIC_NEUTRAL: 'Basis',
    XDS_FLAG_BETA_DIVERSE: 'Beta',
    XDS_FLAG_BETA_FEMALE: 'Beta',
    XDS_FLAG_BETA_MALE: 'Beta',
    XDS_FLAG_BETA_NEUTRAL: 'Beta',
    XDS_FLAG_INSIDER_DIVERSE: 'Insidx',
    XDS_FLAG_INSIDER_FEMALE: 'Insiderin',
    XDS_FLAG_INSIDER_MALE: 'Insider',
    XDS_FLAG_INSIDER_NEUTRAL: 'Insider',
    XDS_FLAG_MODERATOR_DIVERSE: 'Moderatx',
    XDS_FLAG_MODERATOR_FEMALE: 'Moderatorin',
    XDS_FLAG_MODERATOR_MALE: 'Moderator',
    XDS_FLAG_MODERATOR_NEUTRAL: 'Moderator',
    XDS_FLAG_NEW_DIVERSE: 'Neu',
    XDS_FLAG_NEW_FEMALE: 'Neu',
    XDS_FLAG_NEW_MALE: 'Neu',
    XDS_FLAG_NEW_NEUTRAL: 'Neu',
    XDS_FLAG_PREMIUM_DIVERSE: 'Premium',
    XDS_FLAG_PREMIUM_FEMALE: 'Premium',
    XDS_FLAG_PREMIUM_MALE: 'Premium',
    XDS_FLAG_PREMIUM_NEUTRAL: 'Premium',
    XDS_FLAG_PROBUSINESS_DIVERSE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_FEMALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_MALE: 'ProBusiness',
    XDS_FLAG_PROBUSINESS_NEUTRAL: 'ProBusiness',
    XDS_FLAG_PROCOACH_DIVERSE: 'ProCoach',
    XDS_FLAG_PROCOACH_FEMALE: 'ProCoach',
    XDS_FLAG_PROCOACH_MALE: 'ProCoach',
    XDS_FLAG_PROCOACH_NEUTRAL: 'ProCoach',
    XDS_FLAG_PROJOBS_DIVERSE: 'ProJobs',
    XDS_FLAG_PROJOBS_FEMALE: 'ProJobs',
    XDS_FLAG_PROJOBS_MALE: 'ProJobs',
    XDS_FLAG_PROJOBS_NEUTRAL: 'ProJobs',
    XDS_FLAG_PROTRAINER_DIVERSE: 'ProTrainx',
    XDS_FLAG_PROTRAINER_FEMALE: 'ProTrainerin',
    XDS_FLAG_PROTRAINER_MALE: 'ProTrainer',
    XDS_FLAG_PROTRAINER_NEUTRAL: 'ProTrainer',
    XDS_INPUT_BAR_CLEAR_BUTTON_A11Y: 'Eingabe löschen',
    XDS_MINI_BADGE_A11Y: 'Neue Benachrichtigung',
    'XDS_NOTIFICATION_BADGE_GENERIC_A11Y.one': 'Eine neue Benachrichtigung',
    'XDS_NOTIFICATION_BADGE_GENERIC_A11Y.other':
      '{value} neue Benachrichtigungen',
    XDS_SKELETON_GENERIC_A11Y: 'Wird geladen',
    XDS_STAR_RATING_A11Y: 'Bewertung: {rating} von 5 Sternen',
    XDS_STAR_RATING_NO_RATING_A11Y: 'Keine Bewertung vorhanden',
    XE_SIGN_UP_FOR_FREE: 'Jetzt kostenlos registrieren!',
    XING_FAQ_GUIDE_URL:
      'https://help.xing.com/hc/de/articles/33816993574801-Netzwerken-so-geht-s?segment=b2c ',
    XINGID_ADD_LEAD_SUCCESS: '{displayName} als Lead hinzugefügt',
    XINGID_REMOVE_LEAD_SUCCESS: '{displayName} als Lead entfernt',
    XWS_100_APP_PERMISSION_VENDOR_VIDEOS:
      'Zugriff auf die Video-API für Werbetreibende',
    XWS_100_APP_PERMISSION_VENDOR_VIDEOS_HEADING: 'XING Video-API',
    XWS_100_GADGET_FORGOT_LOGIN: 'Zugangsdaten vergessen?',
    XWS_100_GADGET_LOGIN_FAILED_INFO:
      'Die Kombination Deiner Zugangsdaten ist nicht korrekt.',
    XWS_100_GADGET_PASSWORD: 'Passwort',
    XWS_100_GADGET_USERNAME: 'Benutzername',
    XWS_100_LOGIN_WITH_XING_CREDENTIALS:
      'Bitte logg Dich mit Deinen XING Zugangsdaten ein und erlaube der Anwendung {application_name} Zugriff auf Deine bei XING gespeicherten Daten.',
    XWS_100_NOT_MEMBER_YET: 'Noch nicht bei XING?',
    XWS_100_SIGN_IN: 'Einloggen',
    XWS_ERROR_LOGIN_COOKIE:
      'Um Dich einloggen zu können, müssen die Cookies für XING in Deinem Browser erlaubt bzw. aktiviert sein. Um herauszufinden, wie das geht, such am einfachsten im Hilfebereich Deines Browsers nach "Cookies".',
  },
};
